(function(){"use strict";try{if(typeof document!="undefined"){var t=document.createElement("style");t.appendChild(document.createTextNode(".attendee-avatar[data-v-1d9b6940]{display:flex;align-items:center;justify-content:center;position:relative}.avatar-icon[data-v-1d9b6940]{border-radius:50%;display:flex;align-items:center;justify-content:center;font-weight:600;text-transform:uppercase;user-select:none;position:relative;z-index:1;box-sizing:border-box;overflow:hidden}.avatar-image[data-v-1d9b6940]{width:100%;height:100%;object-fit:cover;border-radius:50%;position:absolute;top:0;left:0;transition:opacity .3s ease-in-out}.avatar-initials[data-v-1d9b6940]{position:relative;z-index:2;font-weight:600;text-transform:uppercase}.speaking-ring[data-v-1d9b6940]{position:absolute;border-radius:50%;border:2px solid var(--1b35bcb4);z-index:0;opacity:0;transform-origin:center;transition:opacity .4s ease-out .5s,transform .1s ease-out,border-color .4s ease-out .5s}.attendee-avatar[data-speaking=true] .speaking-ring[data-v-1d9b6940]{opacity:1;transition:opacity .2s ease-in,transform .1s ease-out,border-color .2s ease-in;animation:speaking-pulse-1d9b6940 1.2s ease-in-out infinite;--ring-color: var(--1b35bcb4)}@keyframes speaking-pulse-1d9b6940{0%{box-shadow:0 0 0 0 var(--2b1aafb6)}50%{box-shadow:0 0 0 10px var(--590b6e32)}to{box-shadow:0 0 0 20px var(--1505815e)}}.attendee-avatar.size-small .avatar-icon[data-v-1d9b6940]{width:36px;height:36px;font-size:.875rem}.attendee-avatar.size-small .speaking-ring[data-v-1d9b6940]{width:42px;height:42px}.attendee-avatar.size-medium .avatar-icon[data-v-1d9b6940]{width:80px;height:80px;font-size:1.5rem}.attendee-avatar.size-medium .speaking-ring[data-v-1d9b6940]{width:88px;height:88px}.attendee-avatar.size-large .avatar-icon[data-v-1d9b6940]{width:120px;height:120px;font-size:2.5rem}.attendee-avatar.size-large .speaking-ring[data-v-1d9b6940]{width:130px;height:130px}.control-button[data-v-46a84f32]{position:relative;display:flex;flex-direction:column;align-items:center;justify-content:center;width:var(--control-size, 48px);height:var(--control-size, 48px);background:transparent;border:none;color:var(--icon-color, white);cursor:pointer;transition:all .2s ease}.control-button[data-v-46a84f32]:hover:not(:disabled){transform:translateY(-2px)}.control-button[data-v-46a84f32]:active:not(:disabled){transform:translateY(0)}.control-button.active[data-v-46a84f32]{color:var(--active-color, white)}.control-button[data-v-46a84f32]:disabled{opacity:.5;cursor:not-allowed}.control-button.danger[data-v-46a84f32]{color:#ea4335}.permission-prompt[data-v-ff292202]{position:relative;width:100%;height:100%}.permission-modal-overlay[data-v-ff292202]{position:fixed;inset:0;background:#0009;display:flex;align-items:center;justify-content:center;z-index:99999;backdrop-filter:blur(4px)}.permission-modal[data-v-ff292202]{background:#fff;border-radius:12px;box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a;max-width:800px;width:90%;max-height:90vh;overflow:hidden;position:relative;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif}.close-button[data-v-ff292202]{position:absolute;top:16px;right:16px;background:none;border:none;cursor:pointer;padding:8px;color:#6b7280;border-radius:6px;transition:all .2s;display:flex;align-items:center;justify-content:center;z-index:10}.close-button[data-v-ff292202]:hover{background:#f3f4f6;color:#374151}.permission-modal-content[data-v-ff292202]{display:flex;min-height:400px}.illustration-section[data-v-ff292202]{flex:1;display:flex;align-items:center;justify-content:center;padding:32px 24px}.safari-illustration[data-v-ff292202],.chrome-illustration[data-v-ff292202]{display:flex;align-items:center;justify-content:center}.safari-illustration svg[data-v-ff292202],.chrome-illustration svg[data-v-ff292202]{max-width:100%;height:auto}.content-section[data-v-ff292202]{flex:1;padding:48px 32px 32px;display:flex;flex-direction:column;justify-content:center}.modal-title[data-v-ff292202]{font-size:20px;font-weight:500;color:#1f2937;margin:0 0 16px;line-height:1.4}.modal-message[data-v-ff292202]{font-size:14px;color:#6b7280;margin:0 0 32px;line-height:1.5}.instructions[data-v-ff292202]{margin-top:8px}.instruction-list[data-v-ff292202]{display:flex;flex-direction:column;gap:20px}.instruction-item[data-v-ff292202]{display:flex;gap:16px;align-items:flex-start}.step-number[data-v-ff292202]{width:24px;height:24px;border-radius:50%;background:#1976d2;color:#fff;display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:600;flex-shrink:0;margin-top:2px}.step-text[data-v-ff292202]{flex:1;font-size:14px;line-height:1.5;color:#374151}.inline-icon[data-v-ff292202]{display:inline;vertical-align:middle;color:#6b7280;margin:0 4px}@media (max-width: 1024px){.permission-modal[data-v-ff292202]{max-width:700px}}@media (max-width: 768px){.permission-modal[data-v-ff292202]{max-width:95%;margin:16px}.permission-modal-content[data-v-ff292202]{flex-direction:column;min-height:auto}.illustration-section[data-v-ff292202]{padding:24px 16px;min-height:200px}.content-section[data-v-ff292202]{padding:24px 24px 32px}.modal-title[data-v-ff292202]{font-size:18px}.safari-illustration svg[data-v-ff292202],.chrome-illustration svg[data-v-ff292202]{width:250px;height:250px}}@media (max-width: 480px){.permission-modal[data-v-ff292202]{width:calc(100% - 32px);margin:16px}.content-section[data-v-ff292202]{padding:20px 20px 28px}.modal-title[data-v-ff292202]{font-size:16px}.modal-message[data-v-ff292202],.step-text[data-v-ff292202]{font-size:13px}.safari-illustration svg[data-v-ff292202],.chrome-illustration svg[data-v-ff292202]{width:200px;height:200px}.instruction-item[data-v-ff292202]{gap:12px}.instruction-list[data-v-ff292202]{gap:16px}}.audio-meter-container[data-v-908e1937]{width:100%;padding:12px 6px;display:flex;align-items:center;gap:8px;box-sizing:border-box}.mic-icon[data-v-908e1937]{display:flex;align-items:center;justify-content:center;opacity:.8;flex-shrink:0;min-width:24px;width:auto}.audio-meter-bar-background[data-v-908e1937]{flex-grow:1;height:4px;background-color:#fff3;border-radius:2px;position:relative;width:100%}.audio-meter-bar-fill[data-v-908e1937]{position:absolute;height:100%;background-color:#fff;border-radius:2px;transition:width .05s ease-out}.audio-meter-thumb[data-v-908e1937]{position:absolute;width:10px;height:10px;background-color:#fff;border-radius:50%;transform:translate(-50%,-50%);top:50%;box-shadow:0 1px 2px #0000004d;transition:left .05s ease-out}")),document.head.appendChild(t)}}catch(a){console.error("vite-plugin-css-injected-by-js",a)}})();
var pt = Object.defineProperty, gt = Object.defineProperties;
var wt = Object.getOwnPropertyDescriptors;
var $e = Object.getOwnPropertySymbols;
var kt = Object.prototype.hasOwnProperty, yt = Object.prototype.propertyIsEnumerable;
var Be = (n, t) => (t = Symbol[n]) ? t : Symbol.for("Symbol." + n);
var Fe = (n, t, a) => t in n ? pt(n, t, { enumerable: !0, configurable: !0, writable: !0, value: a }) : n[t] = a, J = (n, t) => {
  for (var a in t || (t = {}))
    kt.call(t, a) && Fe(n, a, t[a]);
  if ($e)
    for (var a of $e(t))
      yt.call(t, a) && Fe(n, a, t[a]);
  return n;
}, te = (n, t) => gt(n, wt(t));
var de = (n, t, a) => Fe(n, typeof t != "symbol" ? t + "" : t, a);
var y = (n, t, a) => new Promise((o, r) => {
  var s = (h) => {
    try {
      d(a.next(h));
    } catch (c) {
      r(c);
    }
  }, w = (h) => {
    try {
      d(a.throw(h));
    } catch (c) {
      r(c);
    }
  }, d = (h) => h.done ? o(h.value) : Promise.resolve(h.value).then(s, w);
  d((a = a.apply(n, t)).next());
});
var Ve = (n, t, a) => (t = n[Be("asyncIterator")]) ? t.call(n) : (n = n[Be("iterator")](), t = {}, a = (o, r) => (r = n[o]) && (t[o] = (s) => new Promise((w, d, h) => (s = r.call(n, s), h = s.done, Promise.resolve(s.value).then((c) => w({ value: c, done: h }), d)))), a("next"), a("return"), t);
import { getCurrentInstance as Je, hasInjectionContext as St, inject as ye, ref as S, toValue as Ke, watch as Z, provide as bt, isRef as Et, getCurrentScope as Ct, computed as T, shallowRef as ee, onBeforeUnmount as Mt, onUnmounted as Q, watchEffect as re, onMounted as Ge, defineComponent as Se, useCssVars as Pt, createElementBlock as q, openBlock as V, normalizeClass as Xe, createElementVNode as p, createCommentVNode as Ae, normalizeStyle as ae, toDisplayString as ce, renderSlot as Tt, createBlock as Ft, Teleport as At, withModifiers as Dt, createTextVNode as He, createVNode as Rt } from "vue";
import { a as xt, R as F, T as X, D as It, L as jt, b as _t, o as Nt } from "./live-vendor-DtCPNuLC.js";
import { _ as be } from "./_plugin-vue_export-helper-CHgC5LLL.js";
import { c as Lt } from "./SpeakerIcon.vue_vue_type_script_setup_true_lang-B7QhZ13r.js";
import { A as Ze, b as zt, i as ge } from "./index-BmGD5jiK.js";
const ne = /* @__PURE__ */ new WeakMap(), Ot = (...n) => {
  var t;
  const a = n[0], o = (t = Je()) == null ? void 0 : t.proxy;
  if (o == null && !St())
    throw new Error("injectLocal must be called in setup");
  return o && ne.has(o) && a in ne.get(o) ? ne.get(o)[a] : ye(...n);
};
function Ut(n, t) {
  var a;
  const o = (a = Je()) == null ? void 0 : a.proxy;
  if (o == null)
    throw new Error("provideLocal must be called in setup");
  ne.has(o) || ne.set(o, /* @__PURE__ */ Object.create(null));
  const r = ne.get(o);
  return r[n] = t, bt(n, t);
}
function xe(n, t) {
  const a = Symbol(n.name || "InjectionState"), o = void 0;
  return [(...w) => {
    const d = n(...w);
    return Ut(a, d), d;
  }, () => Ot(a, o)];
}
typeof WorkerGlobalScope != "undefined" && globalThis instanceof WorkerGlobalScope;
const qe = () => {
};
function $t(n, t) {
  function a(...o) {
    return new Promise((r, s) => {
      Promise.resolve(n(() => t.apply(this, o), { fn: t, thisArg: this, args: o })).then(r).catch(s);
    });
  }
  return a;
}
function Bt(...n) {
  let t = 0, a, o = !0, r = qe, s, w, d, h, c;
  !Et(n[0]) && typeof n[0] == "object" ? { delay: w, trailing: d = !0, leading: h = !0, rejectOnCancel: c = !1 } = n[0] : [w, d = !0, h = !0, c = !1] = n;
  const i = () => {
    a && (clearTimeout(a), a = void 0, r(), r = qe);
  };
  return (v) => {
    const l = Ke(w), f = Date.now() - t, g = () => s = v();
    return i(), l <= 0 ? (t = Date.now(), g()) : (f > l && (h || !o) ? (t = Date.now(), g()) : d && (s = new Promise((E, b) => {
      r = c ? b : E, a = setTimeout(() => {
        t = Date.now(), o = !0, E(g()), i();
      }, Math.max(0, l - f));
    })), !h && !a && (a = setTimeout(() => o = !0, l)), o = !1, s);
  };
}
function Vt(n, t = 200, a = !1, o = !0, r = !1) {
  return $t(
    Bt(t, a, o, r),
    n
  );
}
function $a(n, t = 200, a = !0, o = !0) {
  if (t <= 0)
    return n;
  const r = S(Ke(n)), s = Vt(() => {
    r.value = n.value;
  }, t, a, o);
  return Z(n, () => s()), r;
}
const oe = /* @__PURE__ */ new Map();
function Ht(n) {
  const t = Ct();
  function a(d) {
    var h;
    const c = oe.get(n) || /* @__PURE__ */ new Set();
    c.add(d), oe.set(n, c);
    const i = () => r(d);
    return (h = t == null ? void 0 : t.cleanups) == null || h.push(i), i;
  }
  function o(d) {
    function h(...c) {
      r(h), d(...c);
    }
    return a(h);
  }
  function r(d) {
    const h = oe.get(n);
    h && (h.delete(d), h.size || s());
  }
  function s() {
    oe.delete(n);
  }
  function w(d, h) {
    var c;
    (c = oe.get(n)) == null || c.forEach((i) => i(d, h));
  }
  return { on: a, once: o, off: r, emit: w, reset: s };
}
const [Ba, Zt] = xe(
  (n = "attendee") => {
    const t = S({
      role: n,
      isLive: !1,
      title: "",
      description: "",
      startedAt: null,
      attendeeCount: 0,
      host: null
    }), a = T(() => t.value.role), o = T(() => t.value.isLive), r = T(() => t.value.role === "host"), s = T(() => t.value.role === "attendee"), w = T(() => t.value.attendeeCount), d = T(() => t.value.host);
    return {
      state: t,
      role: a,
      isLive: o,
      isHost: r,
      isAttendee: s,
      attendeeCount: w,
      host: d,
      setRole: (l) => {
        t.value.role = l;
      },
      setLive: (l) => {
        t.value.isLive = l, l && !t.value.startedAt ? t.value.startedAt = /* @__PURE__ */ new Date() : l || (t.value.startedAt = null);
      },
      setStreamInfo: (l, f) => {
        t.value.title = l, t.value.description = f;
      },
      setHost: (l) => {
        t.value.host = l;
      },
      updateAttendeeCount: (l) => {
        t.value.attendeeCount = l;
      }
    };
  }
);
function Va() {
  const n = Zt();
  if (!n)
    throw new Error("useStreamContext must be used within a StreamProvider");
  return n;
}
const [qt, Wt] = xe(
  (n) => ee(n)
);
function Jt() {
  return Wt();
}
function W() {
  const n = Jt();
  if (!n)
    throw new Error(
      "Room context not found. Please ensure useProvideRoomContext() is called in a parent component."
    );
  return n;
}
function Ha(n = {}) {
  const t = n.room || new xt(n.roomOptions), a = qt(t);
  return Mt(() => y(this, null, function* () {
    if (a.value && a.value.state !== "disconnected")
      try {
        yield a.value.disconnect();
      } catch (o) {
      }
  })), {
    room: a
  };
}
let se = null;
function we(n = {}) {
  if (se)
    return se;
  const { skipAutoEnable: t = !1, enabledControls: a = [] } = n, o = S(!1), r = S(!1), s = S(!1), w = S({ state: "unknown" }), d = S({
    state: "unknown"
  }), h = S({
    state: "unknown"
  }), c = (C, M, I) => {
    const O = C === "camera" ? w : C === "microphone" ? d : h;
    O.value = {
      state: M,
      error: I,
      lastAttempt: /* @__PURE__ */ new Date()
    };
  }, i = ee(null), e = ee(null), v = ee(null), l = S(""), f = S(""), g = S(""), E = () => {
    var C;
    return (C = i.value) == null ? void 0 : C.getVideoTracks()[0];
  }, b = () => {
    var C;
    return (C = e.value) == null ? void 0 : C.getAudioTracks()[0];
  }, m = () => {
    var C;
    return (C = v.value) == null ? void 0 : C.getVideoTracks()[0];
  }, k = (C) => y(this, null, function* () {
    if (C !== o.value)
      if (C)
        try {
          i.value && (i.value.getTracks().forEach((I) => {
            I.readyState === "live" && I.stop();
          }), i.value = null);
          const M = yield navigator.mediaDevices.getUserMedia({
            video: {
              deviceId: l.value ? { exact: l.value } : void 0,
              width: { ideal: 1280 },
              height: { ideal: 720 }
            }
          });
          return i.value = M, o.value = !0, c("camera", "granted"), Promise.resolve();
        } catch (M) {
          return M instanceof Error && (M.name === "NotAllowedError" ? c(
            "camera",
            "denied",
            "Camera access denied by user"
          ) : M.name === "NotFoundError" ? c(
            "camera",
            "denied",
            "No camera device found"
          ) : c("camera", "unknown", M.message)), o.value = !1, Promise.reject(M);
        }
      else
        return i.value && (i.value.getTracks().forEach((I, O) => {
          I.readyState === "live" && I.stop();
        }), i.value = null), o.value = !1, Promise.resolve();
  }), P = () => y(this, null, function* () {
    return k(!o.value);
  }), D = (C) => y(this, null, function* () {
    if (C !== r.value)
      if (C)
        try {
          e.value && (e.value.getTracks().forEach((I) => {
            I.readyState === "live" && I.stop();
          }), e.value = null);
          const M = yield navigator.mediaDevices.getUserMedia({
            audio: te(J({}, Re), {
              deviceId: f.value ? { exact: f.value } : void 0
            })
          });
          return e.value = M, r.value = !0, c("microphone", "granted"), Promise.resolve();
        } catch (M) {
          return M instanceof Error && (M.name === "NotAllowedError" ? c(
            "microphone",
            "denied",
            "Microphone access denied by user"
          ) : M.name === "NotFoundError" ? c(
            "microphone",
            "denied",
            "No microphone device found"
          ) : c("microphone", "unknown", M.message)), r.value = !1, Promise.reject(M);
        }
      else
        return e.value && (e.value.getTracks().forEach((M) => {
          M.readyState === "live" && M.stop();
        }), e.value = null), r.value = !1, Promise.resolve();
  }), z = () => y(this, null, function* () {
    return D(!r.value);
  }), j = (C) => y(this, null, function* () {
    if (C !== s.value)
      if (C)
        try {
          if (!navigator.mediaDevices || !navigator.mediaDevices.getDisplayMedia)
            throw new Error("Screen sharing is not supported in this browser");
          v.value && (v.value.getTracks().forEach((O) => O.stop()), v.value = null);
          const M = yield navigator.mediaDevices.getDisplayMedia({
            video: {
              width: { ideal: 1920 },
              height: { ideal: 1080 },
              frameRate: { ideal: 30 }
            },
            audio: !1
          }), I = M.getVideoTracks()[0];
          return I && I.addEventListener("ended", () => {
            j(!1);
          }), v.value = M, s.value = !0, c("screenshare", "granted"), Promise.resolve();
        } catch (M) {
          return M && typeof M == "object" && "name" in M ? M.name === "NotAllowedError" ? c(
            "screenshare",
            "prompt",
            // Keep as prompt to allow immediate retry
            "Screen sharing cancelled by user"
          ) : M.name === "NotSupportedError" ? c(
            "screenshare",
            "denied",
            "Screen sharing not supported in this browser"
          ) : M.name === "NotFoundError" ? c(
            "screenshare",
            "denied",
            "No screen sharing source available"
          ) : c(
            "screenshare",
            "unknown",
            M.message || "Unknown screen share error"
          ) : c(
            "screenshare",
            "unknown",
            "Unknown screen share error"
          ), s.value = !1, Promise.reject(M);
        }
      else
        return v.value && (v.value.getTracks().forEach((M) => M.stop()), v.value = null), s.value = !1, Promise.resolve();
  }), L = () => y(this, null, function* () {
    return j(!s.value);
  }), N = (C, M) => {
    C === "camera" ? l.value !== M && (l.value = M, o.value && (i.value && (i.value.getTracks().forEach((O, x) => {
      O.readyState === "live" && O.stop();
    }), i.value = null), setTimeout(() => {
      navigator.mediaDevices.getUserMedia({
        video: {
          deviceId: { exact: M },
          width: { ideal: 1280 },
          height: { ideal: 720 }
        }
      }).then((I) => {
        i.value = I, o.value = !0;
      }).catch((I) => {
      });
    }, 100))) : C === "microphone" ? (f.value = M, r.value && D(!0).catch(console.error)) : C === "speaker" && (g.value = M);
  }, R = () => {
    i.value && (i.value.getTracks().forEach((C) => {
      C.readyState === "live" && C.stop();
    }), i.value = null), e.value && (e.value.getTracks().forEach((C) => {
      C.readyState === "live" && C.stop();
    }), e.value = null), v.value && (v.value.getTracks().forEach((C) => {
      C.readyState === "live" && C.stop();
    }), v.value = null), o.value = !1, r.value = !1, s.value = !1;
  };
  Q(() => {
    se === _ && (R(), se = null);
  });
  const _ = {
    // Media states
    isCameraEnabled: o,
    isMicrophoneEnabled: r,
    isScreenShareEnabled: s,
    // Browser permission states
    cameraPermission: w,
    microphonePermission: d,
    screenSharePermission: h,
    // Media streams
    cameraStream: i,
    microphoneStream: e,
    screenShareStream: v,
    // Selected devices
    selectedCamera: l,
    selectedMicrophone: f,
    selectedSpeaker: g,
    // Media control methods
    toggleCamera: P,
    toggleMicrophone: z,
    toggleScreenShare: L,
    setCameraEnabled: k,
    setMicrophoneEnabled: D,
    setScreenShareEnabled: j,
    setDeviceSelection: N,
    // Get current tracks
    getCameraTrack: E,
    getMicrophoneTrack: b,
    getScreenShareTrack: m,
    // Permission management
    updateBrowserPermission: c,
    // Cleanup
    cleanup: R
  };
  return se = _, t || setTimeout(() => y(this, null, function* () {
    const C = i.value && o.value, M = e.value && r.value, I = a.includes("camera") && !C, O = a.includes("microphone") && !M;
    if (!(!I && !O) && !(C && M))
      try {
        const x = yield navigator.mediaDevices.getUserMedia({
          video: I ? {
            deviceId: l.value ? { exact: l.value } : void 0,
            width: { ideal: 1280 },
            height: { ideal: 720 }
          } : !1,
          audio: O ? te(J({}, Re), {
            deviceId: f.value ? { exact: f.value } : void 0
          }) : !1
        }), B = x.getVideoTracks(), le = x.getAudioTracks();
        I && B.length > 0 && (i.value && i.value.getTracks().forEach((K) => {
          K.readyState === "live" && K.stop();
        }), i.value = new MediaStream([B[0]]), o.value = !0, c("camera", "granted")), O && le.length > 0 && (e.value && e.value.getTracks().forEach((K) => {
          K.readyState === "live" && K.stop();
        }), e.value = new MediaStream([le[0]]), r.value = !0, c("microphone", "granted"));
      } catch (x) {
        x && typeof x == "object" && "name" in x && x.name === "NotAllowedError" && (I && c(
          "camera",
          "denied",
          "Camera access denied by user"
        ), O && c(
          "microphone",
          "denied",
          "Microphone access denied by user"
        )), I && k(!0).catch((B) => {
        }), O && D(!0).catch((B) => {
        });
      }
  }), 0), _;
}
const Kt = 1e4, Re = {
  // Enable WebRTC's built-in audio processing
  echoCancellation: !0,
  noiseSuppression: !0,
  autoGainControl: !0,
  // Audio quality optimized for voice
  sampleRate: 48e3,
  // High quality sample rate
  channelCount: 1,
  // Mono for voice calls (saves bandwidth)
  sampleSize: 16,
  // 16-bit audio
  // Latency optimization
  latency: 0.01
  // 10ms target latency
};
class Gt {
  constructor(t) {
    de(this, "name", "KrispNoiseFilter");
    de(this, "krispProcessor");
    de(this, "processedTrack");
    this.krispProcessor = t;
  }
  init(t) {
    return y(this, null, function* () {
      this.processedTrack = t.track;
    });
  }
  restart(t) {
    return y(this, null, function* () {
      yield this.init(t);
    });
  }
  destroy() {
    return y(this, null, function* () {
    });
  }
  setEnabled(t) {
    return y(this, null, function* () {
      return this.krispProcessor.setEnabled(t);
    });
  }
  getStats() {
    var t, a;
    return (a = (t = this.krispProcessor).getStats) == null ? void 0 : a.call(t);
  }
  setAggressiveness(t) {
    var a, o;
    return (o = (a = this.krispProcessor).setAggressiveness) == null ? void 0 : o.call(a, t);
  }
}
let ve = null, ie = null;
const We = /* @__PURE__ */ new Set();
function Xt() {
  return y(this, null, function* () {
    return ve || ie || (ie = Promise.race([
      // Dynamic import with timeout
      import(
        /* webpackIgnore: true */
        /* @vite-ignore */
        // @ts-expect-error ignore
        "https://cdn.jsdelivr.net/npm/@livekit/krisp-noise-filter@0.3.4/+esm"
      ).then((n) => (ve = n, ve)),
      // Timeout promise
      new Promise((n, t) => {
        setTimeout(() => {
          t(new Error("Enhanced Krisp load timeout"));
        }, Kt);
      })
    ]).catch((n) => (ie = null, null)), ie);
  });
}
var ke = /* @__PURE__ */ ((n) => (n.Disconnected = "disconnected", n.Connecting = "connecting", n.Connected = "connected", n.Reconnecting = "reconnecting", n.SignalReconnecting = "signalReconnecting", n))(ke || {});
function Qt(n) {
  return y(this, null, function* () {
    try {
      yield n.mediaStreamTrack.applyConstraints({
        echoCancellation: !0,
        noiseSuppression: !0,
        autoGainControl: !0
      });
    } catch (t) {
    }
  });
}
function Yt(n) {
  return y(this, null, function* () {
    try {
      const t = yield Xt();
      if (!t)
        return;
      const { KrispNoiseFilter: a, isKrispNoiseFilterSupported: o } = t;
      if (!o())
        return;
      const r = a({
        model: "meeting",
        // Optimized for meeting scenarios
        aggressiveness: 0.7
        // Balanced approach - not too aggressive to avoid cutting off speech
      }), s = new Gt(r);
      yield n.setProcessor(s), yield s.setEnabled(!0), ea(r, n);
    } catch (t) {
    }
  });
}
function ea(n, t) {
  const a = setInterval(() => {
    var o;
    try {
      n.getStats && n.getStats().cpuUsage > 0.8 && ((o = n.setAggressiveness) == null || o.call(n, 0.5));
    } catch (r) {
      clearInterval(a);
    }
  }, 5e3);
  t.on("ended", () => {
    clearInterval(a);
  });
}
function Ie() {
  const n = W(), t = S(
    "disconnected"
    /* Disconnected */
  ), a = S(null), o = We, r = (c) => {
    const i = c.name || "default", e = () => {
      t.value = "connected", a.value = null;
    }, v = (m) => {
      t.value = "disconnected", m === It.SERVER_SHUTDOWN && (a.value = new Error(
        "Server is shutting down. Please try again later."
      ));
    }, l = () => {
      t.value = "reconnecting";
    }, f = () => {
      t.value = "connected", a.value = null;
    }, g = (m) => y(this, null, function* () {
      if (m.source === X.Source.Microphone && m.track instanceof jt) {
        const k = m.trackSid || m.track.mediaStreamTrack.id;
        if (o.has(k))
          return;
        o.add(k);
        try {
          yield Qt(m.track), yield Yt(m.track);
        } catch (P) {
          o.delete(k);
        }
      }
    }), E = (m) => {
      var k;
      if (m.source === X.Source.Microphone) {
        const P = m.trackSid || ((k = m.track) == null ? void 0 : k.mediaStreamTrack.id);
        P && o.has(P) && o.delete(P);
      }
    }, b = (m) => {
      t.value = m;
    };
    return c.on(F.Connected, e).on(F.Disconnected, v).on(F.Reconnecting, l).on(F.Reconnected, f).on(F.LocalTrackPublished, g).on(F.LocalTrackUnpublished, E).on(F.ConnectionStateChanged, b), () => {
      c.off(F.Connected, e).off(F.Disconnected, v).off(F.Reconnecting, l).off(F.Reconnected, f).off(F.LocalTrackPublished, g).off(F.LocalTrackUnpublished, E).off(F.ConnectionStateChanged, b), o.clear(), o.size === 0 && We.delete(i);
    };
  };
  re((c) => {
    const i = n.value;
    if (!i)
      return;
    i.name, i.state === "connected" && t.value !== "connected" && (t.value = "connected");
    const e = r(i);
    c(e);
  });
  const s = () => t.value === "connected", w = () => y(this, null, function* () {
    const c = n.value;
    if (!(!c || !s()))
      try {
        const i = we(), e = c.localParticipant, v = (l) => Array.from(e.trackPublications.values()).some(
          (f) => f.source === l
        );
        i.isCameraEnabled.value && !v(X.Source.Camera) && (i.cameraStream.value && (i.cameraStream.value.getTracks().forEach((l) => {
          l.stop();
        }), i.cameraStream.value = null), yield c.localParticipant.setCameraEnabled(!0), yield new Promise((l) => setTimeout(l, 300))), i.isMicrophoneEnabled.value && !v(X.Source.Microphone) && (i.microphoneStream.value && (i.microphoneStream.value.getTracks().forEach((l) => {
          l.stop();
        }), i.microphoneStream.value = null), yield c.localParticipant.setMicrophoneEnabled(!0, te(J({}, Re), {
          deviceId: i.selectedMicrophone.value ? { exact: i.selectedMicrophone.value } : void 0
        })), yield new Promise((l) => setTimeout(l, 300))), i.isScreenShareEnabled.value && !v(X.Source.ScreenShare) && (i.screenShareStream.value && (i.screenShareStream.value.getTracks().forEach((l) => {
          l.stop();
        }), i.screenShareStream.value = null), yield c.localParticipant.setScreenShareEnabled(!0));
      } catch (i) {
        throw i;
      }
  });
  return {
    connectionState: t,
    connect: (c) => y(this, null, function* () {
      const i = n.value;
      if (!i)
        throw new Error("Room not available.");
      if (t.value === "connecting" || t.value === "connected")
        return { canJoin: !0, message: "Already connected to the session." };
      try {
        t.value = "connecting", a.value = null;
        const e = yield Ze.joinLiveSession(
          c.licenseId,
          c.participantToken
        );
        return e.canJoin ? (yield i.connect(
          e.serverUrl,
          c.participantToken,
          c.connectOptions
        ), s() && (yield new Promise((v) => setTimeout(v, 1e3)), c.skipMediaTransfer || (yield w())), e) : (t.value = "disconnected", e);
      } catch (e) {
        throw t.value = "disconnected", a.value = e, e;
      }
    }),
    disconnect: (c) => y(this, null, function* () {
      const i = n.value;
      if (i)
        try {
          yield i.disconnect(), yield Ze.leaveLiveSession(
            c.licenseId,
            c.participantToken
          ), t.value = "disconnected", a.value = null;
        } catch (e) {
          t.value = "disconnected";
        }
    }),
    error: a,
    isConnected: s,
    transferLocalMediaToRoom: w
  };
}
function Za() {
  const n = W(), { connectionState: t } = Ie(), a = S(), o = S({});
  let r;
  const s = (e) => {
    if (!e) return {};
    try {
      return JSON.parse(e);
    } catch (v) {
      return {};
    }
  };
  re((e) => {
    const v = n.value, l = t.value === ke.Connected;
    if (!v || !l) {
      a.value = void 0, o.value = {};
      return;
    }
    r = _t(v).subscribe({
      next: ({ metadata: f }) => {
        a.value = f, o.value = s(f);
      },
      error: (f) => {
      }
    }), e(() => {
      r && (r.unsubscribe(), r = void 0);
    });
  });
  const w = T(() => o.value.recording === !0), d = T(() => o.value.connectionMinutes), h = T(() => {
    const e = d.value;
    return e ? Math.max(0, e.maxEntity - e.entity) : 0;
  }), c = T(() => {
    const e = d.value;
    return !e || e.maxEntity === 0 ? 0 : Math.max(0, (e.maxEntity - e.entity) / e.maxEntity * 100);
  }), i = () => {
    const e = n.value;
    e && t.value === ke.Connected && (a.value = e.metadata, o.value = s(e.metadata));
  };
  return Q(() => {
    r && (r.unsubscribe(), r = void 0);
  }), {
    rawMetadata: a,
    metadata: o,
    isRecording: w,
    connectionMinutes: d,
    remainingMinutes: h,
    remainingPercentage: c,
    refreshMetadata: i
  };
}
function qa() {
  const n = W(), t = ee(/* @__PURE__ */ new Map()), a = ee(null), o = ee(null), r = (e) => {
    const v = () => {
      const E = /* @__PURE__ */ new Map();
      e.localParticipant && E.set(e.localParticipant.identity, e.localParticipant), e.remoteParticipants.forEach((b, m) => {
        E.set(m, b);
      }), t.value = E;
    };
    v();
    const l = () => {
      t.value = /* @__PURE__ */ new Map(), a.value = null, o.value = null;
    }, f = (E, b, m) => {
      a.value = {
        participant: m,
        track: E,
        publication: b,
        trackKind: E.kind
      };
    }, g = (E, b, m) => {
      o.value = {
        participant: m,
        track: E,
        publication: b,
        trackKind: E.kind
      };
    };
    return e.on(F.ParticipantConnected, v).on(F.ParticipantDisconnected, v).on(F.Connected, v).on(F.Disconnected, l).on(F.TrackSubscribed, f).on(F.TrackUnsubscribed, g), () => {
      e.off(F.ParticipantConnected, v).off(F.ParticipantDisconnected, v).off(F.Connected, v).off(F.Disconnected, l).off(F.TrackSubscribed, f).off(F.TrackUnsubscribed, g);
    };
  };
  re((e) => {
    const v = n.value;
    if (!v) {
      t.value = /* @__PURE__ */ new Map();
      return;
    }
    const l = r(v);
    e(l);
  });
  const s = T(
    () => Array.from(t.value.values())
  ), w = T(() => t.value.size), d = T(() => {
    const e = n.value;
    return e == null ? void 0 : e.localParticipant;
  }), h = T(
    () => s.value.filter((e) => e !== d.value)
  );
  return {
    participants: s,
    participantCount: w,
    localParticipant: d,
    remoteParticipants: h,
    getParticipant: (e) => t.value.get(e),
    onTrackSubscribed: a,
    onTrackUnsubscribed: o,
    getParticipantMetadata: (e) => {
      const v = t.value.get(e), l = JSON.parse((v == null ? void 0 : v.metadata) || "{}");
      return te(J({}, l), {
        identity: e
      });
    }
  };
}
const De = Ht("permission-denied");
function je() {
  const n = W(), t = T(() => {
    var f;
    return (f = n.value) == null ? void 0 : f.localParticipant;
  }), a = S(!1), o = S(!1), r = S(!1), s = S(), w = S(), d = S();
  re((f) => {
    const g = t.value;
    if (!g) {
      a.value = !1, o.value = !1, r.value = !1, s.value = void 0, w.value = void 0, d.value = void 0;
      return;
    }
    const b = Nt(g).subscribe({
      next: (m) => {
        a.value = m.isCameraEnabled, o.value = m.isMicrophoneEnabled, r.value = m.isScreenShareEnabled, s.value = m.cameraTrack, w.value = m.microphoneTrack, d.value = g.getTrackPublication(
          X.Source.ScreenShare
        );
      },
      error: (m) => {
      }
    });
    f(() => {
      b.unsubscribe();
    });
  });
  const h = (f) => y(this, null, function* () {
    var b;
    const g = t.value;
    if (!g)
      throw new Error("Local participant not available");
    const E = ((b = g.permissions) == null ? void 0 : b.canPublishSources) || [];
    if (f && !E.includes(
      1
      /* CAMERA */
    )) {
      De.emit({ type: "camera" });
      return;
    }
    try {
      yield g.setCameraEnabled(f), f && we({ skipAutoEnable: !0 }).updateBrowserPermission("camera", "granted");
    } catch (m) {
      throw m;
    }
  }), c = () => y(this, null, function* () {
    yield h(!a.value);
  }), i = (f) => y(this, null, function* () {
    var b;
    const g = t.value;
    if (!g)
      throw new Error("Local participant not available");
    const E = ((b = g.permissions) == null ? void 0 : b.canPublishSources) || [];
    if (f && !E.includes(
      2
      /* MICROPHONE */
    )) {
      De.emit({ type: "microphone" });
      return;
    }
    try {
      yield g.setMicrophoneEnabled(f), f && we({ skipAutoEnable: !0 }).updateBrowserPermission("microphone", "granted");
    } catch (m) {
      throw m;
    }
  }), e = () => y(this, null, function* () {
    yield i(!o.value);
  }), v = (f) => y(this, null, function* () {
    var b;
    const g = t.value;
    if (!g)
      throw new Error("Local participant not available");
    const E = ((b = g.permissions) == null ? void 0 : b.canPublishSources) || [];
    if (f && !E.includes(
      3
      /* SCREEN_SHARE */
    )) {
      De.emit({ type: "screenshare" });
      return;
    }
    try {
      yield g.setScreenShareEnabled(f);
    } catch (m) {
      throw m;
    }
  });
  return {
    localParticipant: t,
    isCameraEnabled: a,
    isMicrophoneEnabled: o,
    isScreenShareEnabled: r,
    cameraTrack: s,
    microphoneTrack: w,
    screenShareTrack: d,
    toggleCamera: c,
    toggleMicrophone: e,
    toggleScreenShare: () => y(this, null, function* () {
      yield v(!r.value);
    }),
    setCameraEnabled: h,
    setMicrophoneEnabled: i,
    setScreenShareEnabled: v
  };
}
function ta(n = {}) {
  const t = W(), a = S([]), o = S([]), r = S([]), s = S(""), w = S(""), d = S(""), h = S(!1), c = S(!1);
  let i = !1, e = !1;
  const v = (k = !1) => y(this, null, function* () {
    try {
      let P = yield navigator.mediaDevices.enumerateDevices();
      const D = P.some((R) => R.kind === "videoinput" && !R.label) && !i, z = P.some((R) => R.kind === "audioinput" && !R.label) && !e;
      if ((D || z) && !k) {
        const R = yield navigator.mediaDevices.getUserMedia({
          video: D,
          audio: z
        });
        i = i || D, e = e || z, R.getTracks().forEach((_) => _.stop()), P = yield navigator.mediaDevices.enumerateDevices();
      }
      const j = [], L = [], N = [];
      P.forEach((R) => {
        let _ = R.label;
        if (!_)
          switch (R.kind) {
            case "videoinput":
              _ = i ? `Camera ${j.length + 1}` : "";
              break;
            case "audioinput":
              _ = e ? `Microphone ${L.length + 1}` : "";
              break;
            case "audiooutput":
              _ = `Speaker ${N.length + 1}`;
              break;
            default:
              _ = `${R.kind} (${R.deviceId.slice(0, 8)})`;
          }
        if (_) {
          const C = {
            deviceId: R.deviceId,
            label: _,
            kind: R.kind
          };
          switch (R.kind) {
            case "videoinput":
              j.push(C);
              break;
            case "audioinput":
              L.push(C);
              break;
            case "audiooutput":
              N.push(C);
              break;
          }
        }
      }), a.value = j, o.value = L, r.value = N, h.value = j.length > 1, c.value = L.length > 1, !s.value && j.length > 0 && (s.value = j[0].deviceId), !w.value && L.length > 0 && (w.value = L[0].deviceId), !d.value && N.length > 0 && (d.value = N[0].deviceId);
    } catch (P) {
      throw P;
    }
  }), l = (k) => y(this, null, function* () {
    const P = t.value;
    if (!P || P.state !== "connected") {
      s.value = k;
      return;
    }
    try {
      yield P.switchActiveDevice("videoinput", k), s.value = k;
    } catch (D) {
      throw D;
    }
  }), f = (k) => y(this, null, function* () {
    const P = t.value;
    if (!P || P.state !== "connected") {
      w.value = k;
      return;
    }
    try {
      yield P.switchActiveDevice("audioinput", k), w.value = k;
    } catch (D) {
      throw D;
    }
  }), g = (k) => y(this, null, function* () {
    const P = t.value;
    if (!P || P.state !== "connected") {
      d.value = k;
      return;
    }
    try {
      yield P.switchActiveDevice("audiooutput", k), d.value = k;
    } catch (D) {
      throw D;
    }
  });
  let E = null;
  const b = () => {
    E && clearTimeout(E), E = setTimeout(() => {
      v(!0);
    }, 500);
  };
  return Ge(() => {
    navigator.mediaDevices.addEventListener("devicechange", b), v(!0);
  }), Q(() => {
    navigator.mediaDevices.removeEventListener(
      "devicechange",
      b
    ), E && clearTimeout(E);
  }), {
    videoDevices: a,
    audioInputDevices: o,
    audioOutputDevices: r,
    selectedVideoDevice: s,
    selectedAudioInputDevice: w,
    selectedAudioOutputDevice: d,
    enumerateDevices: v,
    switchVideoDevice: l,
    switchAudioInputDevice: f,
    switchAudioOutputDevice: g,
    hasMultipleCameras: h,
    hasMultipleMicrophones: c,
    updatePermissionStatus: (k, P) => {
      k === "video" ? i = P : k === "audio" && (e = P), v(!0);
    }
  };
}
function aa() {
  const n = W(), { localParticipant: t } = je(), a = S(!1), o = S(), r = S(), s = !!(navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia);
  re(() => {
    if (!t.value) {
      o.value = void 0, r.value = void 0, a.value = !1;
      return;
    }
    o.value = t.value.getTrackPublication(
      X.Source.ScreenShare
    ), r.value = t.value.getTrackPublication(
      X.Source.ScreenShareAudio
    ), a.value = !!(o.value && o.value.track && !o.value.isMuted);
  });
  const w = (...i) => y(this, [...i], function* (c = {}) {
    var l;
    const e = n.value, v = t.value;
    if (!e || !v)
      throw new Error("Room not connected");
    if (!s)
      throw new Error("Screen sharing is not supported in this browser");
    try {
      const f = {
        audio: (l = c.audio) != null ? l : !1,
        video: c.displaySurface ? { displaySurface: c.displaySurface } : !0
      };
      yield v.setScreenShareEnabled(!0, f);
    } catch (f) {
      if (!(f && typeof f == "object" && "name" in f && f.name === "NotAllowedError")) throw f;
    }
  }), d = () => y(this, null, function* () {
    const c = t.value;
    if (c)
      try {
        yield c.setScreenShareEnabled(!1);
      } catch (i) {
        throw i;
      }
  });
  return {
    isScreenShareEnabled: a,
    isScreenShareSupported: s,
    screenShareTrack: o,
    screenShareAudioTrack: r,
    toggleScreenShare: () => y(this, null, function* () {
      a.value ? yield d() : yield w();
    }),
    startScreenShare: w,
    stopScreenShare: d
  };
}
function Wa(n = {}) {
  const { skipMediaPermissions: t = !1 } = n, a = ye("controlsConfig", []), o = W(), r = ta({}), s = r.videoDevices, w = r.audioInputDevices, d = r.audioOutputDevices, h = r.enumerateDevices, c = r.updatePermissionStatus, { isScreenShareSupported: i } = aa(), e = we({
    skipAutoEnable: t,
    enabledControls: a
  });
  Z(
    () => e.cameraPermission.value.state,
    (u, A) => {
      u === "granted" && A !== "granted" && c("video", !0);
    }
  ), Z(
    () => e.microphonePermission.value.state,
    (u, A) => {
      u === "granted" && A !== "granted" && c("audio", !0);
    }
  ), Z(
    () => r.selectedVideoDevice.value,
    (u) => {
      u && u !== e.selectedCamera.value && (e.selectedCamera.value = u);
    }
  ), Z(
    () => r.selectedAudioInputDevice.value,
    (u) => {
      u && u !== e.selectedMicrophone.value && (e.selectedMicrophone.value = u);
    }
  ), Z(
    () => r.selectedAudioOutputDevice.value,
    (u) => {
      u && u !== e.selectedSpeaker.value && (e.selectedSpeaker.value = u);
    }
  ), Z(
    () => e.selectedCamera.value,
    (u) => {
      u && u !== r.selectedVideoDevice.value && (r.selectedVideoDevice.value = u);
    }
  ), Z(
    () => e.selectedMicrophone.value,
    (u) => {
      u && u !== r.selectedAudioInputDevice.value && (r.selectedAudioInputDevice.value = u);
    }
  ), Z(
    () => e.selectedSpeaker.value,
    (u) => {
      u && u !== r.selectedAudioOutputDevice.value && (r.selectedAudioOutputDevice.value = u);
    }
  );
  const { isConnected: v } = Ie();
  let l = null;
  try {
    l = je();
  } catch (u) {
  }
  const f = T(() => v()), g = T(() => !t), E = T(() => f.value && l ? l.isCameraEnabled.value : e.isCameraEnabled.value), b = T(() => f.value && l ? l.isMicrophoneEnabled.value : e.isMicrophoneEnabled.value), m = T(() => f.value && l ? l.isScreenShareEnabled.value : e.isScreenShareEnabled.value), k = T({
    get: () => e.selectedCamera.value,
    set: (u) => {
      e.selectedCamera.value = u;
    }
  }), P = T({
    get: () => e.selectedMicrophone.value,
    set: (u) => {
      e.selectedMicrophone.value = u;
    }
  }), D = T({
    get: () => e.selectedSpeaker.value,
    set: (u) => {
      e.selectedSpeaker.value = u;
    }
  }), z = T(() => e.cameraStream.value), j = T(() => e.microphoneStream.value), L = T(() => e.screenShareStream.value), N = T(() => s.value.length > 1), R = S(null), _ = S(!1), C = S(!1), M = S(!1), I = S(1), O = S(!1), x = S(null), B = () => {
    e.cameraStream.value && e.cameraStream.value.getTracks().forEach((A) => {
      A.readyState === "live" && A.stop();
    }), e.microphoneStream.value && e.microphoneStream.value.getTracks().forEach((A) => {
      A.readyState === "live" && A.stop();
    }), document.querySelectorAll(".camera-transition-overlay").forEach((A) => {
      A.parentElement && A.parentElement.removeChild(A);
    });
    const u = R.value;
    u && (u.src = "", R.value = null), _.value = !1;
  }, le = () => y(this, null, function* () {
    try {
      if (f.value && l)
        try {
          yield l.toggleCamera();
        } catch (u) {
          yield e.toggleCamera();
        }
      else
        yield e.toggleCamera();
    } catch (u) {
      throw new Error("Failed to toggle camera");
    }
  }), K = () => y(this, null, function* () {
    try {
      if (f.value && l)
        try {
          yield l.setCameraEnabled(!0);
        } catch (u) {
          yield e.setCameraEnabled(!0);
        }
      else
        yield e.setCameraEnabled(!0);
    } catch (u) {
      throw new Error("Failed to start camera");
    }
  }), _e = () => {
    try {
      if (f.value && l)
        try {
          l.setCameraEnabled(!1);
        } catch (u) {
          e.setCameraEnabled(!1);
        }
      else
        e.setCameraEnabled(!1);
      B();
    } catch (u) {
      throw new Error("Failed to stop camera");
    }
  }, Qe = () => y(this, null, function* () {
    try {
      if (f.value && l)
        try {
          yield l.toggleMicrophone();
        } catch (u) {
          yield e.toggleMicrophone();
        }
      else
        yield e.toggleMicrophone();
    } catch (u) {
      throw new Error("Failed to toggle microphone");
    }
  }), Ye = () => y(this, null, function* () {
    try {
      if (f.value && l)
        try {
          yield l.setMicrophoneEnabled(!0);
        } catch (u) {
          yield e.setMicrophoneEnabled(!0);
        }
      else
        yield e.setMicrophoneEnabled(!0);
    } catch (u) {
      throw new Error("Failed to start microphone");
    }
  }), et = () => {
    try {
      if (f.value && l)
        try {
          l.setMicrophoneEnabled(!1);
        } catch (u) {
          e.setMicrophoneEnabled(!1);
        }
      else
        e.setMicrophoneEnabled(!1);
      B();
    } catch (u) {
      throw new Error("Failed to stop microphone");
    }
  }, tt = () => y(this, null, function* () {
    try {
      if (f.value && l)
        try {
          yield l.toggleScreenShare();
        } catch (u) {
          if (u instanceof Error && u.name === "NotAllowedError")
            throw u;
          yield e.toggleScreenShare();
        }
      else
        yield e.toggleScreenShare();
    } catch (u) {
      throw u && typeof u == "object" && "name" in u && u.name === "NotAllowedError" ? u : new Error("Failed to toggle screen share");
    }
  }), at = () => y(this, null, function* () {
    try {
      if (f.value && l)
        try {
          yield l.setScreenShareEnabled(!0);
        } catch (u) {
          if (u instanceof Error && u.name === "NotAllowedError")
            throw u;
          yield e.setScreenShareEnabled(!0);
        }
      else
        yield e.setScreenShareEnabled(!0);
    } catch (u) {
      throw u && typeof u == "object" && "name" in u && u.name === "NotAllowedError" ? u : new Error("Failed to start screen share");
    }
  }), nt = () => {
    try {
      if (f.value && l)
        try {
          l.setScreenShareEnabled(!1);
        } catch (u) {
          e.setScreenShareEnabled(!1);
        }
      else
        e.setScreenShareEnabled(!1);
    } catch (u) {
      throw new Error("Failed to stop screen share");
    }
  }, rt = (u, A) => y(this, null, function* () {
    var $;
    try {
      if ((u === "camera" || u === "microphone") && (yield h(!1)), e.setDeviceSelection(u, A), f.value && (($ = o.value) == null ? void 0 : $.state) === "connected")
        try {
          switch (u) {
            case "camera":
              yield r.switchVideoDevice(A);
              break;
            case "microphone":
              yield r.switchAudioInputDevice(A);
              break;
            case "speaker":
              yield r.switchAudioOutputDevice(A);
              break;
          }
        } catch (H) {
        }
    } catch (H) {
      throw new Error(`Failed to change ${u} device`);
    }
  }), ot = () => y(this, null, function* () {
    if (s.value.length <= 1)
      throw new Error("Need at least two cameras to flip");
    try {
      const u = k.value, A = ["front", "selfie", "user", "face"], $ = ["back", "rear", "environment", "main"], H = [], G = [], Ee = [];
      s.value.forEach((U) => {
        const Ue = U.label.toLowerCase();
        A.some((Te) => Ue.includes(Te)) ? H.push(U) : $.some((Te) => Ue.includes(Te)) ? G.push(U) : Ee.push(U);
      });
      let Ce = s.value.find(
        (U) => U.deviceId === u
      );
      Ce || (Ce = s.value[0]);
      const Oe = Ce.label.toLowerCase();
      let Me = A.some(
        (U) => Oe.includes(U)
      ), Pe = $.some(
        (U) => Oe.includes(U)
      );
      !Me && !Pe && (Me = H.length > 0 && H.some((U) => U.deviceId === u), Pe = G.length > 0 && G.some((U) => U.deviceId === u));
      let Y;
      Me && G.length > 0 ? Y = G[0].deviceId : Pe && H.length > 0 ? Y = H[0].deviceId : H.length > 0 && G.length > 0 ? Y = G[0].deviceId : s.value.length >= 2 ? Y = u === s.value[0].deviceId ? s.value[1].deviceId : s.value[0].deviceId : Y = u, E.value ? (e.cameraStream.value && e.cameraStream.value.getTracks().forEach((U) => {
        U.readyState === "live" && U.stop();
      }), yield _e(), yield new Promise((U) => setTimeout(U, 200)), e.selectedCamera.value = Y, yield K()) : e.selectedCamera.value = Y;
    } catch (u) {
      throw B(), new Error("Failed to flip camera");
    }
  }), ue = () => y(this, null, function* () {
    try {
      const u = t || a.length === 0;
      if (yield h(u), g.value && !(s.value.some(($) => $.label) || w.value.some(($) => $.label)))
        try {
          const $ = a.includes("camera"), H = a.includes("microphone");
          if (!$ && !H)
            return;
          (yield navigator.mediaDevices.getUserMedia({
            video: $,
            audio: H
          })).getTracks().forEach((Ee) => {
            Ee.stop();
          }), yield h(!1);
        } catch ($) {
          $ instanceof Error && $.name === "NotAllowedError" && (e.updateBrowserPermission(
            "camera",
            "denied",
            "Camera access denied by user"
          ), e.updateBrowserPermission(
            "microphone",
            "denied",
            "Microphone access denied by user"
          ));
        }
      s.value.forEach((A, $) => {
      }), s.value.length > 0 && !e.selectedCamera.value && (e.selectedCamera.value = s.value[0].deviceId), w.value.length > 0 && !e.selectedMicrophone.value && (e.selectedMicrophone.value = w.value[0].deviceId), d.value.length > 0 && !e.selectedSpeaker.value && (e.selectedSpeaker.value = d.value[0].deviceId);
    } catch (u) {
      u && typeof u == "object" && "name" in u && u.name === "NotAllowedError" && (e.updateBrowserPermission(
        "camera",
        "denied",
        "Camera access denied by user"
      ), e.updateBrowserPermission(
        "microphone",
        "denied",
        "Microphone access denied by user"
      ));
    }
  }), st = (u) => {
    x.value = u, u && (u.volume = M.value ? 0 : I.value, u.muted = M.value, C.value && u.paused ? u.play().catch((A) => {
    }) : !C.value && !u.paused && u.pause());
  }, Ne = () => {
    O.value = !!(document.fullscreenElement || document.webkitFullscreenElement);
  }, it = () => y(this, null, function* () {
    if (!x.value)
      throw new Error("No video element set");
    try {
      yield x.value.play(), C.value = !0;
    } catch (u) {
      throw u;
    }
  }), ct = () => {
    if (!x.value)
      throw new Error("No video element set");
    x.value.pause(), C.value = !1;
  }, lt = () => {
    C.value = !C.value, x.value && (C.value ? x.value.play().catch((u) => {
    }) : x.value.pause());
  }, ut = () => {
    M.value = !M.value, x.value && (x.value.muted = M.value, x.value.volume = M.value ? 0 : I.value);
  }, dt = (u) => {
    const A = Math.max(0, Math.min(1, u));
    I.value = A, M.value = A === 0, x.value && (x.value.volume = A, x.value.muted = M.value);
  }, Le = () => y(this, null, function* () {
    var A;
    const u = ((A = x.value) == null ? void 0 : A.parentElement) || x.value;
    if (!u)
      throw new Error("No element to fullscreen");
    try {
      u.requestFullscreen ? yield u.requestFullscreen() : u.webkitRequestFullscreen && (yield u.webkitRequestFullscreen()), O.value = !0;
    } catch ($) {
      throw $;
    }
  }), ze = () => y(this, null, function* () {
    try {
      document.fullscreenElement ? yield document.exitFullscreen() : document.webkitFullscreenElement && (yield document.webkitExitFullscreen()), O.value = !1;
    } catch (u) {
      throw u;
    }
  }), vt = () => y(this, null, function* () {
    O.value ? yield ze() : yield Le();
  }), ht = T(() => e.cameraPermission.value), mt = T(
    () => e.microphonePermission.value
  ), ft = T(
    () => e.screenSharePermission.value
  );
  return Ge(() => {
    ue(), navigator.mediaDevices.addEventListener("devicechange", ue);
  }), Q(() => {
    navigator.mediaDevices.removeEventListener("devicechange", ue), document.removeEventListener("fullscreenchange", Ne), document.removeEventListener(
      "webkitfullscreenchange",
      Ne
    ), B();
  }), {
    // Device lists
    videoDevices: s,
    audioInputDevices: w,
    audioOutputDevices: d,
    // Media states
    isCameraEnabled: E,
    isMicrophoneEnabled: b,
    isScreenShareEnabled: m,
    isScreenShareSupported: i,
    hasMultipleCameras: N,
    // Browser permission states
    cameraPermission: ht,
    microphonePermission: mt,
    screenSharePermission: ft,
    // Selected devices
    selectedCamera: k,
    selectedMicrophone: P,
    selectedSpeaker: D,
    // Streams
    cameraStream: z,
    microphoneStream: j,
    screenShareStream: L,
    // Control methods
    toggleCamera: le,
    toggleMicrophone: Qe,
    toggleScreenShare: tt,
    startCamera: K,
    stopCamera: _e,
    startMicrophone: Ye,
    stopMicrophone: et,
    startScreenShare: at,
    stopScreenShare: nt,
    // Device management
    handleDeviceChange: rt,
    handleCameraFlip: ot,
    // Utility
    loadDevices: ue,
    ensureResourcesCleanup: B,
    // Attendee playback controls
    isPlaying: C,
    isMuted: M,
    volume: I,
    isFullscreen: O,
    currentVideoElement: x,
    // Playback methods
    togglePlay: lt,
    play: it,
    pause: ct,
    toggleMute: ut,
    setVolume: dt,
    toggleFullscreen: vt,
    enterFullscreen: Le,
    exitFullscreen: ze,
    setVideoElement: st
  };
}
function na(n = {}) {
  const t = W(), { connectionState: a } = Ie(), o = S([]);
  let r = 0;
  const s = (i) => {
    const e = (v, l, f, g) => {
      var b;
      const E = {
        id: `msg-${r++}`,
        data: v,
        participant: l ? {
          identity: l.identity,
          name: l.name,
          sid: l.sid
        } : void 0,
        topic: g,
        timestamp: Date.now()
      };
      o.value.push(E), (b = n.onDataReceived) == null || b.call(n, E);
    };
    return i.on(F.DataReceived, e), () => {
      i.off(F.DataReceived, e);
    };
  };
  re((i) => {
    const e = t.value;
    if (!e) return;
    const v = s(e);
    i(v);
  });
  const w = (v, ...l) => y(this, [v, ...l], function* (i, e = {}) {
    const f = t.value;
    if (!f || a.value !== ke.Connected)
      throw new Error("Room not connected");
    const { topic: g, reliable: E = !0, destinationIdentities: b } = e;
    try {
      b && b.length > 0 ? yield f.localParticipant.publishData(i, {
        reliable: E,
        topic: g,
        destinationIdentities: b
      }) : yield f.localParticipant.publishData(i, { reliable: E, topic: g });
    } catch (m) {
      throw m;
    }
  }), d = (v, ...l) => y(this, [v, ...l], function* (i, e = {}) {
    const f = new TextEncoder().encode(i);
    yield w(f, e);
  }), h = (v, ...l) => y(this, [v, ...l], function* (i, e = {}) {
    const f = JSON.stringify(i);
    yield d(f, e);
  }), c = () => {
    o.value = [], r = 0;
  };
  return Q(() => {
    c();
  }), {
    messages: o,
    sendData: w,
    sendText: d,
    sendJSON: h,
    clearMessages: c
  };
}
function Ja() {
  const n = S([]), t = W(), a = na({
    onDataReceived: (s) => {
      var w, d, h, c, i;
      if (s.topic === "chat")
        try {
          const e = new TextDecoder().decode(s.data), v = JSON.parse(e), l = (d = t.value) == null ? void 0 : d.remoteParticipants.get(
            ((w = s.participant) == null ? void 0 : w.identity) || ""
          ), f = JSON.parse(
            (l == null ? void 0 : l.metadata) || "{}"
          ), g = {
            id: s.id,
            text: v.text,
            senderName: ((h = s.participant) == null ? void 0 : h.name) || ((c = s.participant) == null ? void 0 : c.identity) || "Unknown",
            senderIdentity: ((i = s.participant) == null ? void 0 : i.identity) || "unknown",
            senderIdentityType: f == null ? void 0 : f.identityType,
            senderAvatar: f == null ? void 0 : f.avatar,
            senderRole: f == null ? void 0 : f.role,
            timestamp: s.timestamp,
            isOwn: !1
          };
          n.value.push(g);
        } catch (e) {
        }
    }
  });
  return {
    messages: n,
    sendMessage: (s) => y(this, null, function* () {
      if (!s.trim()) return;
      const w = t.value, d = w == null ? void 0 : w.localParticipant;
      yield a.sendJSON({ text: s }, { topic: "chat" });
      const h = JSON.parse((d == null ? void 0 : d.metadata) || "{}"), c = {
        id: `chat-${Date.now()}-${Math.random().toString(36).substring(2, 6)}`,
        text: s,
        senderName: (d == null ? void 0 : d.name) || "Anonymous",
        senderIdentity: d == null ? void 0 : d.identity,
        senderIdentityType: h == null ? void 0 : h.identityType,
        senderAvatar: h == null ? void 0 : h.avatar,
        senderRole: h == null ? void 0 : h.role,
        timestamp: Date.now(),
        isOwn: !0
      };
      return n.value.push(c), c;
    }),
    clearMessages: () => {
      n.value = [], a.clearMessages();
    }
  };
}
const [Ka, ra] = xe(
  (n = "attendee") => {
    const t = S({
      role: n,
      title: "",
      description: ""
    }), a = T(() => t.value.role), o = T(() => t.value.role === "host"), r = T(() => t.value.role === "attendee");
    return {
      state: t,
      role: a,
      isHost: o,
      isAttendee: r,
      setRole: (d) => {
        t.value.role = d;
      },
      setRoomInfo: (d, h) => {
        t.value.title = d, t.value.description = h;
      }
    };
  }
);
function Ga() {
  const n = ra();
  if (!n)
    throw new Error("useRoomState must be used within a RoomProvider");
  return n;
}
const oa = ["data-speaking", "data-audio-level"], sa = ["src", "alt"], ia = /* @__PURE__ */ Se({
  __name: "AttendeeAvatar",
  props: {
    name: { default: "Attendee" },
    image: {},
    size: { default: "medium" },
    isSpeaking: { type: Boolean, default: !1 },
    backgroundColor: { default: "rgba(255, 255, 255, 0.1)" },
    textColor: { default: "#e8eaed" },
    borderColor: { default: "" },
    showSpeakingAnimation: { type: Boolean, default: !0 },
    audioLevel: { default: 0 },
    speakingRingColor: { default: "#34a853" }
  },
  setup(n) {
    Pt((e) => ({
      "1b35bcb4": t.speakingRingColor,
      "2b1aafb6": s.value.start,
      "590b6e32": s.value.middle,
      "1505815e": s.value.end
    }));
    const t = n, a = S(!1), o = S(!1), r = T(() => {
      const e = t.showSpeakingAnimation && t.isSpeaking;
      return t.isSpeaking, e;
    }), s = T(() => {
      const e = t.speakingRingColor, v = e.match(/hsl\((\d+),\s*(\d+)%,\s*(\d+)%\)/);
      if (v) {
        const [, l, f, g] = v;
        return {
          start: `hsla(${l}, ${f}%, ${g}%, 0.7)`,
          middle: `hsla(${l}, ${f}%, ${g}%, 0.2)`,
          end: `hsla(${l}, ${f}%, ${g}%, 0)`
        };
      }
      return {
        start: e + "70",
        // 70% opacity
        middle: e + "33",
        // 20% opacity
        end: e + "00"
        // 0% opacity
      };
    }), w = () => {
      a.value = !0, o.value = !1;
    }, d = () => {
      o.value = !0, a.value = !1;
    }, h = T(() => t.image && o.value && !a.value), c = () => {
      o.value = !1, a.value = !1;
    };
    Z(
      () => t.image,
      () => {
        c();
      }
    );
    const i = T(() => {
      const e = t.name.trim();
      if (!e) return "?";
      const v = e.split(/\s+/);
      return v.length >= 2 ? (v[0][0] + v[1][0]).toUpperCase() : e.length === 1 ? e.toUpperCase() : e.slice(0, 2).toUpperCase();
    });
    return (e, v) => (V(), q("div", {
      class: Xe(["attendee-avatar", [`size-${e.size}`, { "is-speaking": r.value }]]),
      "data-speaking": e.isSpeaking,
      "data-audio-level": e.audioLevel
    }, [
      p("div", {
        class: "avatar-icon",
        style: ae({
          backgroundColor: h.value ? "transparent" : e.backgroundColor,
          color: h.value ? "transparent" : e.textColor,
          borderColor: e.borderColor,
          borderWidth: e.borderColor ? "2px" : "0",
          borderStyle: e.borderColor ? "solid" : "none"
        })
      }, [
        e.image ? (V(), q("img", {
          key: 0,
          src: e.image,
          alt: e.name,
          style: ae({ opacity: o.value && !a.value ? 1 : 0 }),
          class: "avatar-image",
          onLoad: d,
          onError: w
        }, null, 44, sa)) : Ae("", !0),
        h.value ? Ae("", !0) : (V(), q("span", {
          key: 1,
          class: "avatar-initials",
          style: ae({
            color: e.textColor,
            backgroundColor: "transparent"
          })
        }, ce(i.value), 5))
      ], 4),
      r.value ? (V(), q("div", {
        key: 0,
        class: "speaking-ring",
        style: ae({ transform: `scale(${1 + e.audioLevel * 0.15})` })
      }, null, 4)) : Ae("", !0)
    ], 10, oa));
  }
}), Xa = /* @__PURE__ */ be(ia, [["__scopeId", "data-v-1d9b6940"]]), ca = ["disabled", "title"], la = /* @__PURE__ */ Se({
  __name: "ControlButton",
  props: {
    active: { type: Boolean, default: !1 },
    danger: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    title: { default: "" },
    noBackground: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(n) {
    const t = n;
    return (a, o) => (V(), q("button", {
      class: Xe(["control-button", {
        active: a.active,
        danger: a.danger,
        disabled: a.disabled,
        "no-background": t.noBackground
      }]),
      disabled: a.disabled,
      title: a.title,
      onClick: o[0] || (o[0] = (r) => a.$emit("click"))
    }, [
      Tt(a.$slots, "default", {}, void 0, !0)
    ], 10, ca));
  }
}), Qa = /* @__PURE__ */ be(la, [["__scopeId", "data-v-46a84f32"]]), ua = { class: "permission-prompt" }, da = { class: "permission-modal-content" }, va = { class: "illustration-section" }, ha = {
  key: 0,
  class: "safari-illustration"
}, ma = {
  key: 1,
  class: "chrome-illustration"
}, fa = { class: "content-section" }, pa = { class: "modal-title" }, ga = { class: "modal-message" }, wa = { class: "instructions" }, ka = {
  key: 0,
  class: "instruction-list"
}, ya = { class: "instruction-item" }, Sa = { class: "step-text" }, ba = {
  key: 1,
  class: "instruction-list"
}, Ea = /* @__PURE__ */ Se({
  __name: "PermissionPrompt",
  props: {
    cameraPermission: {},
    microphonePermission: {}
  },
  emits: ["close"],
  setup(n, { emit: t }) {
    const a = n, o = t, r = T(() => {
      const i = navigator.userAgent.toLowerCase();
      return i.includes("safari") && !i.includes("chrome") ? "Safari" : i.includes("chrome") ? "Chrome" : i.includes("firefox") ? "Firefox" : "Browser";
    }), s = T(() => r.value === "Safari"), w = T(() => window.location.hostname), d = T(() => {
      const i = a.cameraPermission.state === "denied" || a.cameraPermission.state === "prompt", e = a.microphonePermission.state === "denied" || a.microphonePermission.state === "prompt";
      return i && e ? `${r.value} is blocked from using your microphone and camera` : i ? `${r.value} is blocked from using your camera` : e ? `${r.value} is blocked from using your microphone` : "Media access required";
    }), h = T(() => {
      const i = a.cameraPermission.state === "denied" || a.cameraPermission.state === "prompt", e = a.microphonePermission.state === "denied" || a.microphonePermission.state === "prompt";
      return i && e ? "To join this meeting, you need to allow access to your microphone and camera." : i ? "To join this meeting with video, you need to allow access to your camera." : e ? "To join this meeting, you need to allow access to your microphone." : "Media access is required to join this meeting.";
    }), c = () => {
      o("close");
    };
    return (i, e) => (V(), q("div", ua, [
      (V(), Ft(At, { to: "body" }, [
        p("div", {
          class: "permission-modal-overlay",
          onClick: c
        }, [
          p("div", {
            class: "permission-modal",
            onClick: e[0] || (e[0] = Dt(() => {
            }, ["stop"]))
          }, [
            p("button", {
              class: "close-button",
              onClick: c
            }, e[1] || (e[1] = [
              p("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                p("path", {
                  d: "M18 6L6 18M6 6L18 18",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                })
              ], -1)
            ])),
            p("div", da, [
              p("div", va, [
                s.value ? (V(), q("div", ha, e[2] || (e[2] = [
                  p("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    "xmlns:xlink": "http://www.w3.org/1999/xlink",
                    width: "300",
                    height: "300",
                    viewBox: "0 0 1080 1080"
                  }, [
                    p("defs", null, [
                      p("path", {
                        id: "a",
                        d: "M325.25 383.21c82.843 0 150-67.157 150-150s-67.157-150-150-150-150 67.157-150 150 67.157 150 150 150Z"
                      })
                    ]),
                    p("g", {
                      fill: "none",
                      "fill-rule": "evenodd"
                    }, [
                      p("path", {
                        fill: "#FFF",
                        "fill-rule": "nonzero",
                        d: "M0 0h1080v1080H0z"
                      }),
                      p("g", {
                        stroke: "#191C1E",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "3"
                      }, [
                        p("path", { d: "M116.5 973.246V791.83a72.32 72.32 0 0 1 72.32-72.33h767.26M116.5 853.55h839.58" }),
                        p("path", {
                          d: "M206.81 804.85c10.416 0 18.86-8.444 18.86-18.86 0-10.416-8.444-18.86-18.86-18.86-10.416 0-18.86 8.444-18.86 18.86 0 10.416 8.444 18.86 18.86 18.86h0Z",
                          fill: "#FF8669",
                          "fill-rule": "nonzero"
                        }),
                        p("path", {
                          d: "M270.32 804.85c10.416 0 18.86-8.444 18.86-18.86 0-10.416-8.444-18.86-18.86-18.86-10.416 0-18.86 8.444-18.86 18.86 0 10.416 8.444 18.86 18.86 18.86h0Z",
                          fill: "#FFB929",
                          "fill-rule": "nonzero"
                        }),
                        p("path", {
                          d: "M333.84 804.85c10.416 0 18.86-8.444 18.86-18.86 0-10.416-8.444-18.86-18.86-18.86-10.416 0-18.86 8.444-18.86 18.86 0 10.416 8.444 18.86 18.86 18.86h0Z",
                          fill: "#6DD58C",
                          "fill-rule": "nonzero"
                        }),
                        p("path", { d: "M490.18 783.44h-63.69m29.13 29.13-29.13-29.13 29.13-29.12m72.7 29.12h63.69m-29.13 29.13 29.13-29.13-29.13-29.12" })
                      ]),
                      p("path", {
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        "stroke-linecap": "round",
                        d: "M116.681 276.5h65.007M469.447 276.5h486.84M469.18 186.5h486.84M116.299 186.5h65.771"
                      }),
                      p("mask", {
                        id: "b",
                        fill: "#fff"
                      }, [
                        p("use", { "xlink:href": "#a" })
                      ]),
                      p("use", {
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "xlink:href": "#a"
                      }),
                      p("g", { mask: "url(#b)" }, [
                        p("path", {
                          fill: "#C2E7FF",
                          d: "M223 169h207v126H223z"
                        }),
                        p("path", {
                          stroke: "#191C1E",
                          "stroke-width": "3",
                          "stroke-linecap": "square",
                          d: "M162 295.5h325M162.345 169.5h325.31"
                        }),
                        p("g", {
                          fill: "#000",
                          "fill-rule": "nonzero"
                        }, [
                          p("path", { d: "M270.085 251.88c-3.263 0-6.197-.953-8.8-2.86-2.603-1.907-4.418-4.583-5.445-8.03l5.72-2.31c.587 2.2 1.632 3.997 3.135 5.39 1.503 1.393 3.318 2.09 5.445 2.09 1.98 0 3.658-.513 5.033-1.54 1.375-1.027 2.062-2.438 2.062-4.235 0-1.65-.605-3.016-1.815-4.097-1.21-1.082-3.3-2.136-6.27-3.163l-2.475-.88c-2.677-.953-4.904-2.282-6.683-3.988-1.778-1.704-2.667-3.969-2.667-6.792a9.88 9.88 0 0 1 1.567-5.39c1.046-1.65 2.512-2.952 4.4-3.905 1.889-.953 4.025-1.43 6.408-1.43 3.41 0 6.142.834 8.195 2.502 2.053 1.669 3.447 3.548 4.18 5.638l-5.445 2.31c-.367-1.32-1.137-2.457-2.31-3.41-1.173-.953-2.695-1.43-4.565-1.43-1.797 0-3.318.477-4.565 1.43-1.247.953-1.87 2.163-1.87 3.63 0 1.357.56 2.484 1.678 3.383 1.118.898 2.85 1.75 5.197 2.557l2.53.88c3.373 1.173 5.977 2.695 7.81 4.565 1.833 1.87 2.75 4.363 2.75 7.48 0 2.567-.65 4.72-1.953 6.463-1.301 1.741-2.97 3.034-5.005 3.877-2.034.843-4.115 1.265-6.242 1.265ZM298.08 251.88c-2.017 0-3.813-.394-5.39-1.182-1.577-.789-2.805-1.898-3.685-3.328-.88-1.43-1.32-3.062-1.32-4.895 0-1.943.513-3.62 1.54-5.032 1.027-1.412 2.42-2.494 4.18-3.245 1.76-.752 3.722-1.128 5.885-1.128 1.65 0 3.144.156 4.482.468 1.339.311 2.411.669 3.218 1.072v-1.485c0-1.797-.66-3.254-1.98-4.373-1.32-1.118-3.025-1.677-5.115-1.677-1.43 0-2.787.32-4.07.963-1.283.641-2.31 1.512-3.08 2.612l-4.07-3.135c1.21-1.723 2.814-3.062 4.813-4.015 1.998-.953 4.189-1.43 6.572-1.43 4.033 0 7.16 1 9.377 2.998 2.219 1.998 3.328 4.794 3.328 8.387V251h-5.775v-3.465h-.33c-.807 1.247-1.962 2.282-3.465 3.108-1.503.825-3.208 1.237-5.115 1.237Zm1.045-4.84c1.467 0 2.805-.357 4.015-1.072a7.646 7.646 0 0 0 2.833-2.888 7.857 7.857 0 0 0 1.017-3.905c-.88-.513-1.888-.917-3.025-1.21a14.253 14.253 0 0 0-3.575-.44c-2.31 0-4.006.458-5.087 1.375-1.082.917-1.623 2.127-1.623 3.63 0 1.32.495 2.402 1.485 3.245.99.843 2.31 1.265 3.96 1.265ZM321.95 228.12h-5.115v-5.17h5.115v-2.31c0-2.933.908-5.243 2.723-6.93 1.815-1.687 4.115-2.53 6.902-2.53 1.577 0 3.025.22 4.345.66v5.775a20.492 20.492 0 0 0-1.87-.632 7.314 7.314 0 0 0-1.98-.248c-1.21 0-2.218.385-3.025 1.155-.807.77-1.21 1.852-1.21 3.245v1.815h7.04v5.17h-7.04V251h-5.885v-22.88ZM348.24 251.88c-2.017 0-3.813-.394-5.39-1.182-1.577-.789-2.805-1.898-3.685-3.328-.88-1.43-1.32-3.062-1.32-4.895 0-1.943.513-3.62 1.54-5.032 1.027-1.412 2.42-2.494 4.18-3.245 1.76-.752 3.722-1.128 5.885-1.128 1.65 0 3.144.156 4.483.468 1.338.311 2.41.669 3.217 1.072v-1.485c0-1.797-.66-3.254-1.98-4.373-1.32-1.118-3.025-1.677-5.115-1.677-1.43 0-2.787.32-4.07.963-1.283.641-2.31 1.512-3.08 2.612l-4.07-3.135c1.21-1.723 2.814-3.062 4.813-4.015 1.998-.953 4.189-1.43 6.572-1.43 4.033 0 7.16 1 9.377 2.998 2.219 1.998 3.328 4.794 3.328 8.387V251h-5.775v-3.465h-.33c-.807 1.247-1.962 2.282-3.465 3.108-1.503.825-3.208 1.237-5.115 1.237Zm1.045-4.84c1.467 0 2.805-.357 4.015-1.072a7.646 7.646 0 0 0 2.832-2.888 7.857 7.857 0 0 0 1.018-3.905c-.88-.513-1.888-.917-3.025-1.21a14.253 14.253 0 0 0-3.575-.44c-2.31 0-4.006.458-5.088 1.375-1.081.917-1.622 2.127-1.622 3.63 0 1.32.495 2.402 1.485 3.245.99.843 2.31 1.265 3.96 1.265ZM369.47 222.95h5.61v4.125h.33c.623-1.43 1.696-2.612 3.217-3.547a9.235 9.235 0 0 1 4.923-1.403c1.283 0 2.42.183 3.41.55v6.16c-1.503-.66-2.952-.99-4.345-.99-2.09 0-3.813.807-5.17 2.42-1.357 1.613-2.035 3.575-2.035 5.885V251h-5.94v-28.05ZM394.935 218.825c-1.1 0-2.044-.394-2.833-1.182-.788-.789-1.182-1.733-1.182-2.833s.394-2.035 1.182-2.805a3.91 3.91 0 0 1 2.833-1.155c1.1 0 2.044.385 2.833 1.155.788.77 1.182 1.705 1.182 2.805s-.394 2.044-1.182 2.833c-.789.788-1.733 1.182-2.833 1.182Zm-2.97 4.125h5.94V251h-5.94v-28.05Z" })
                        ])
                      ]),
                      p("path", {
                        d: "M511.74 439.52 317.2 272.28a8 8 0 0 0-13.22 6.07v266a9.51 9.51 0 0 0 17.17 5.65l59.92-81.16 50.64 99.84a17.998 17.998 0 0 0 24.24 7.92h0c2.115-1.068 4-2.542 5.544-4.339a18.016 18.016 0 0 0 4.293-13.124 17.98 17.98 0 0 0-1.907-6.777l-48.75-96.1h90.4a9.516 9.516 0 0 0 8.931-6.209 9.517 9.517 0 0 0-2.721-10.531h0Z",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        fill: "#FFF",
                        "fill-rule": "nonzero",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      p("path", {
                        d: "M937.11 402.88c0-19.507-15.813-35.32-35.32-35.32-19.507 0-35.32 15.813-35.32 35.32v83.58c0 19.507 15.813 35.32 35.32 35.32 19.507 0 35.32-15.813 35.32-35.32v-83.58Z",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        fill: "#FF8669",
                        "fill-rule": "nonzero",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      p("path", {
                        d: "M956.51 487.95a54.72 54.72 0 0 1-109.44 0m54.72 54.72v31.84m-35.32 0h70.64",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      p("path", {
                        d: "M722.69 444.65v-33.56a16.685 16.685 0 0 0-16.74-16.66H594.06a16.702 16.702 0 0 0-11.843 4.849 16.682 16.682 0 0 0-4.927 11.811v121.34c.04 9.213 7.537 16.652 16.75 16.62h111.91c9.212.032 16.706-7.408 16.74-16.62v-28.85l43.34 31.66a11.923 11.923 0 0 0 12.42 1.068 11.925 11.925 0 0 0 6.58-10.588V419.28a11.924 11.924 0 0 0-6.83-10.71 11.916 11.916 0 0 0-12.61 1.53l-42.9 34.55Z",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        fill: "#FF8669",
                        "fill-rule": "nonzero",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      })
                    ])
                  ], -1)
                ]))) : (V(), q("div", ma, e[3] || (e[3] = [
                  p("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "300",
                    height: "300",
                    viewBox: "0 0 1080 1080"
                  }, [
                    p("g", {
                      fill: "none",
                      "fill-rule": "evenodd"
                    }, [
                      p("path", {
                        fill: "#FFF",
                        "fill-rule": "nonzero",
                        d: "M0 0h1080v1080H0z"
                      }),
                      p("path", {
                        d: "M120.5 942.36V210.83a72.32 72.32 0 0 1 72.32-72.33h767.26",
                        fill: "#FFF",
                        "fill-rule": "nonzero"
                      }),
                      p("path", {
                        d: "M120.5 942.36V210.83a72.32 72.32 0 0 1 72.32-72.33h767.26",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      p("path", {
                        d: "M960.08 256.93h-110c-12.94 0-23.43-10.49-23.43-23.43v-71.56a23.428 23.428 0 0 0-23.43-23.44H536.29a23.433 23.433 0 0 0-23.43 23.44v71.56c-.001 12.94-10.49 23.429-23.43 23.43H120.5v137.62h839.58",
                        fill: "#FFF",
                        "fill-rule": "nonzero"
                      }),
                      p("path", {
                        d: "M960.08 256.93h-110c-12.94 0-23.43-10.49-23.43-23.43v-71.56a23.428 23.428 0 0 0-23.43-23.44H536.29a23.433 23.433 0 0 0-23.43 23.44v71.56c-.001 12.94-10.49 23.429-23.43 23.43H120.5v137.62h839.58",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      p("path", {
                        d: "M210.81 223.85c10.416 0 18.86-8.444 18.86-18.86 0-10.416-8.444-18.86-18.86-18.86-10.416 0-18.86 8.444-18.86 18.86 0 10.416 8.444 18.86 18.86 18.86h0Z",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        fill: "#FF8669",
                        "fill-rule": "nonzero",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      p("path", {
                        d: "M274.32 223.85c10.416 0 18.86-8.444 18.86-18.86 0-10.416-8.444-18.86-18.86-18.86-10.416 0-18.86 8.444-18.86 18.86 0 10.416 8.444 18.86 18.86 18.86h0Z",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        fill: "#FFB929",
                        "fill-rule": "nonzero",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      p("path", {
                        d: "M337.84 223.85c10.416 0 18.86-8.444 18.86-18.86 0-10.416-8.444-18.86-18.86-18.86-10.416 0-18.86 8.444-18.86 18.86 0 10.416 8.444 18.86 18.86 18.86h0Z",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        fill: "#6DD58C",
                        "fill-rule": "nonzero",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      p("path", {
                        d: "M670.77 475.25c82.578 0 149.52-66.942 149.52-149.52 0-82.578-66.942-149.52-149.52-149.52-82.578 0-149.52 66.942-149.52 149.52 0 82.578 66.942 149.52 149.52 149.52Z",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        fill: "#FFF",
                        "fill-rule": "nonzero",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      p("path", {
                        d: "M460.21 353.89a38.369 38.369 0 0 1-64.265-31.835 38.364 38.364 0 0 1 28.046-33.32 38.368 38.368 0 0 1 41.119 14.355",
                        fill: "#FFF",
                        "fill-rule": "nonzero"
                      }),
                      p("path", {
                        d: "M460.21 353.89a38.369 38.369 0 0 1-64.265-31.835 38.364 38.364 0 0 1 28.046-33.32 38.368 38.368 0 0 1 41.119 14.355",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      p("path", {
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        fill: "#191C1E",
                        "fill-rule": "nonzero",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        d: "m470.57 298.9 2.52 16.75-15.95-5.72z"
                      }),
                      p("path", {
                        d: "M236.18 329.44h-63.69m29.13 29.13-29.13-29.13 29.13-29.12m72.7 29.12h63.69m-29.13 29.13 29.13-29.13-29.13-29.12",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      p("path", {
                        d: "M354.11 741.88c0-19.507-15.813-35.32-35.32-35.32-19.507 0-35.32 15.813-35.32 35.32v83.58c0 19.507 15.813 35.32 35.32 35.32 19.507 0 35.32-15.813 35.32-35.32v-83.58Z",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        fill: "#FF8669",
                        "fill-rule": "nonzero",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      p("path", {
                        d: "M373.51 826.95a54.72 54.72 0 1 1-109.44 0m54.72 54.72v31.84m-35.32 0h70.64",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      p("path", {
                        d: "m430.59 520.1-42.9 34.55v-33.56a16.683 16.683 0 0 0-16.74-16.66H259.06a16.7 16.7 0 0 0-11.843 4.849 16.682 16.682 0 0 0-4.927 11.811v121.34c.04 9.213 7.537 16.652 16.75 16.62h111.91c9.212.032 16.706-7.408 16.74-16.62v-28.85l43.34 31.66a11.923 11.923 0 0 0 12.42 1.068 11.925 11.925 0 0 0 6.58-10.588V529.28a11.924 11.924 0 0 0-6.83-10.71 11.916 11.916 0 0 0-12.61 1.53h0Z",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        fill: "#FF8669",
                        "fill-rule": "nonzero",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      p("path", {
                        d: "M590.9 274.8h369.18V376H590.9c-27.95-.001-50.61-22.66-50.61-50.61h0c.012-27.943 22.667-50.589 50.61-50.59h0Z",
                        stroke: "#C2E7FF",
                        "stroke-width": "3",
                        fill: "#C2E7FF",
                        "fill-rule": "nonzero",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      p("path", {
                        d: "M625.31 322.08h-27.15a7.88 7.88 0 0 0-7.88 7.88v17.19a7.88 7.88 0 0 0 7.88 7.88h27.15a7.88 7.88 0 0 0 7.88-7.88v-17.19a7.88 7.88 0 0 0-7.88-7.88h0Z",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        fill: "#FFF",
                        "fill-rule": "nonzero",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      p("path", {
                        d: "M595.13 322.09v-12.86a16.764 16.764 0 0 1 16.76-16.8c9.256 0 16.76 7.504 16.76 16.76v12.86",
                        fill: "#FFF",
                        "fill-rule": "nonzero"
                      }),
                      p("path", {
                        d: "M595.13 322.09v-12.86a16.764 16.764 0 0 1 16.76-16.8h0c9.256 0 16.76 7.504 16.76 16.76v12.86",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      p("path", {
                        d: "M670.77 475.25c82.578 0 149.52-66.942 149.52-149.52 0-82.578-66.942-149.52-149.52-149.52-82.578 0-149.52 66.942-149.52 149.52 0 82.578 66.942 149.52 149.52 149.52Z",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        fill: "#FFF",
                        "fill-rule": "nonzero",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      p("path", {
                        d: "M521.29 325.74a149.005 149.005 0 0 0 39.1 100.87h220.75c51.762-56.63 52.26-143.25 1.15-200.47h-223a149.001 149.001 0 0 0-38 99.6h0Z",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        fill: "#FFF",
                        "fill-rule": "nonzero",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      p("path", {
                        d: "M562.74 326.15a79.606 79.606 0 0 0 23.314 56.286 79.608 79.608 0 0 0 56.286 23.314h154.75c30.743-48.56 30.945-110.44.52-159.2H642.34c-43.962 0-79.6 35.638-79.6 79.6h0Z",
                        stroke: "#C2E7FF",
                        "stroke-width": "3",
                        fill: "#C2E7FF",
                        "fill-rule": "nonzero",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      p("path", {
                        d: "M670.77 475.25c82.578 0 149.52-66.942 149.52-149.52 0-82.578-66.942-149.52-149.52-149.52-82.578 0-149.52 66.942-149.52 149.52 0 82.578 66.942 149.52 149.52 149.52Z",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      p("path", {
                        d: "M884.74 525.52 690.2 358.28a8 8 0 0 0-13.22 6.07v266a9.51 9.51 0 0 0 17.17 5.65l59.92-81.16 50.64 99.84a17.998 17.998 0 0 0 24.24 7.92h0c2.115-1.068 4-2.542 5.544-4.339a18.016 18.016 0 0 0 4.293-13.124 17.98 17.98 0 0 0-1.907-6.777l-48.75-96.1h90.4a9.516 9.516 0 0 0 8.931-6.209 9.517 9.517 0 0 0-2.721-10.531h0Z",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        fill: "#FFF",
                        "fill-rule": "nonzero",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      p("g", {
                        transform: "translate(623 279)",
                        stroke: "#191C1E",
                        "stroke-width": "4"
                      }, [
                        p("ellipse", {
                          transform: "rotate(180 84.632 20.5)",
                          cx: "84.632",
                          cy: "20.5",
                          rx: "18.368",
                          ry: "18.5"
                        }),
                        p("path", {
                          "stroke-linecap": "square",
                          d: "M1 20h63"
                        }),
                        p("circle", {
                          cx: "20.5",
                          cy: "60.5",
                          r: "18.5"
                        }),
                        p("path", {
                          "stroke-linecap": "square",
                          d: "M105 60H42"
                        })
                      ])
                    ])
                  ], -1)
                ])))
              ]),
              p("div", fa, [
                p("h3", pa, ce(d.value), 1),
                p("p", ga, ce(h.value), 1),
                p("div", wa, [
                  s.value ? (V(), q("div", ka, [
                    p("div", ya, [
                      e[4] || (e[4] = p("div", { class: "step-number" }, "1", -1)),
                      p("div", Sa, ' Click the "' + ce(r.value) + '" menu and open "Settings for ' + ce(w.value) + '" ', 1)
                    ]),
                    e[5] || (e[5] = p("div", { class: "instruction-item" }, [
                      p("div", { class: "step-number" }, "2"),
                      p("div", { class: "step-text" }, "Allow microphone and camera")
                    ], -1))
                  ])) : (V(), q("div", ba, e[6] || (e[6] = [
                    p("div", { class: "instruction-item" }, [
                      p("div", { class: "step-number" }, "1"),
                      p("div", { class: "step-text" }, [
                        He(" Click the "),
                        p("svg", {
                          width: "20",
                          height: "20",
                          xmlns: "http://www.w3.org/2000/svg",
                          class: "inline-icon"
                        }, [
                          p("g", {
                            fill: "none",
                            "fill-rule": "evenodd",
                            stroke: "currentColor",
                            "stroke-width": "2"
                          }, [
                            p("circle", {
                              cx: "15",
                              cy: "8",
                              r: "2.6"
                            }),
                            p("path", {
                              "stroke-linecap": "round",
                              d: "M2.5 8h8.5"
                            }),
                            p("circle", {
                              cx: "5",
                              cy: "15",
                              r: "2.6"
                            }),
                            p("path", {
                              "stroke-linecap": "round",
                              d: "M17.5 15h-8.5"
                            })
                          ])
                        ]),
                        He(" settings icon in your browser's address bar ")
                      ])
                    ], -1),
                    p("div", { class: "instruction-item" }, [
                      p("div", { class: "step-number" }, "2"),
                      p("div", { class: "step-text" }, " Clear blocked microphone and camera permissions ")
                    ], -1)
                  ])))
                ])
              ])
            ])
          ])
        ])
      ]))
    ]));
  }
}), Ya = /* @__PURE__ */ be(Ea, [["__scopeId", "data-v-ff292202"]]);
function Ca() {
  const n = S(0);
  let t = null, a = null;
  const o = (s) => {
    r();
    try {
      const w = window.AudioContext || window.webkitAudioContext, d = new w(), h = d.createMediaStreamSource(s), c = d.createAnalyser();
      c.fftSize = 32, c.smoothingTimeConstant = 0.8, h.connect(c);
      const i = c.frequencyBinCount, e = new Uint8Array(i);
      t = () => {
        h.disconnect(), d.close();
      };
      const v = () => {
        c.getByteFrequencyData(e);
        let l = 0;
        for (let g = 0; g < e.length; g++) {
          const E = e[g];
          l += E * E;
        }
        const f = Math.sqrt(l / e.length) / 255;
        n.value = Math.min(f * 2, 1);
      };
      a = window.setInterval(v, 1e3 / 30);
    } catch (w) {
      r();
    }
  }, r = () => {
    a && (clearInterval(a), a = null), t && (t(), t = null), n.value = 0;
  };
  return Q(() => {
    r();
  }), {
    audioLevel: n,
    // Only for preview visualization
    startAnalyzing: o,
    stopAnalyzing: r
  };
}
const en = {
  /**
   * Warning thresholds as percentages
   */
  THRESHOLDS: {
    /** First warning threshold - shows when remaining percentage drops to or below this */
    FIRST_WARNING: 10,
    // 10% remaining (6000 minutes with 60k max)
    /** Final warning threshold - shows when remaining percentage drops to or below this */
    FINAL_WARNING: 2,
    // 2% remaining (1200 minutes with 60k max)
    /** Force disconnect threshold - disconnects when remaining percentage drops below this */
    FORCE_DISCONNECT: 1
    // Less than 1% remaining (less than 600 minutes with 10k max)
  }
}, Ma = { class: "audio-meter-container" }, Pa = { class: "mic-icon" }, Ta = { class: "audio-meter-bar-background" }, Fa = /* @__PURE__ */ Se({
  __name: "AudioMeter",
  props: {
    iconColor: { default: "#ffffff" },
    iconSize: { default: 18 }
  },
  setup(n) {
    const t = n, a = Ca(), o = T(() => Math.min(100, Math.round(a.audioLevel.value * 100)));
    return (r, s) => (V(), q("div", Ma, [
      p("div", Pa, [
        Rt(Lt, {
          color: t.iconColor,
          size: t.iconSize
        }, null, 8, ["color", "size"])
      ]),
      p("div", Ta, [
        p("div", {
          class: "audio-meter-bar-fill",
          style: ae({ width: `${o.value}%` })
        }, null, 4),
        p("div", {
          class: "audio-meter-thumb",
          style: ae({ left: `${o.value}%` })
        }, null, 4)
      ])
    ]));
  }
}), tn = /* @__PURE__ */ be(Fa, [["__scopeId", "data-v-908e1937"]]), he = /* @__PURE__ */ new WeakMap(), me = /* @__PURE__ */ new WeakMap();
function an(n = "file-transfer") {
  Math.random().toString(36).substring(7);
  const t = W(), { localParticipant: a } = je(), o = () => {
    const g = t.value;
    if (!g) return null;
    me.has(g) || me.set(g, /* @__PURE__ */ new Map());
    const E = me.get(g);
    if (!E.has(n)) {
      const b = S([]), m = (k) => {
        b.value = [...b.value, k];
      };
      E.set(n, { messages: b, addMessage: m });
    }
    return E.get(n);
  }, r = o(), s = (r == null ? void 0 : r.messages) || S([]), w = S(/* @__PURE__ */ new Map()), d = /* @__PURE__ */ new Map(), h = S(!1), c = S(0), i = () => {
    const g = t.value;
    if (!g)
      return;
    he.has(g) || he.set(g, /* @__PURE__ */ new Set());
    const E = he.get(g);
    if (!E.has(n))
      try {
        g.registerByteStreamHandler(n, (b, m) => y(this, null, function* () {
          var x;
          const k = b.info, P = [];
          b.onProgress = (B) => {
            w.value.set(k.id, B);
          };
          try {
            for (var C = Ve(b), M, I, O; M = !(I = yield C.next()).done; M = !1) {
              const B = I.value;
              P.push(B);
            }
          } catch (I) {
            O = [I];
          } finally {
            try {
              M && (I = C.return) && (yield I.call(C));
            } finally {
              if (O)
                throw O[0];
            }
          }
          const D = new Blob(P, { type: k.mimeType }), z = URL.createObjectURL(D);
          d.set(k.id, D);
          const j = g.remoteParticipants.get(m.identity) || g.localParticipant, L = (j == null ? void 0 : j.name) || (j == null ? void 0 : j.identity) || m.identity, N = JSON.parse((j == null ? void 0 : j.metadata) || "{}"), R = {
            id: `chat-${Date.now()}-${Math.random().toString(36).substring(2, 6)}`,
            streamId: k.id,
            fileName: k.name || "Unnamed File",
            fileSize: k.size || D.size,
            mimeType: k.mimeType || "application/octet-stream",
            senderName: L,
            senderAvatar: N == null ? void 0 : N.avatar,
            senderRole: N == null ? void 0 : N.role,
            senderIdentity: m.identity,
            senderIdentityType: N == null ? void 0 : N.identityType,
            timestamp: k.timestamp,
            isOwn: m.identity === ((x = a.value) == null ? void 0 : x.identity),
            url: z
          }, _ = o();
          _ ? _.addMessage(R) : s.value.push(R), w.value.delete(k.id);
        })), E.add(n);
      } catch (b) {
        b && typeof b == "object" && "message" in b && b.message.includes("already been set") && E.add(n);
      }
  }, e = (g, E, b) => y(this, null, function* () {
    const m = t.value, k = a.value;
    if (!m || !k)
      throw new Error("Room or participant not available");
    try {
      h.value = !0, c.value = 0;
      const D = {
        topic: b || n,
        mimeType: g.type,
        onProgress: (_) => {
          c.value = _, w.value.set("upload", _);
        }
      }, z = yield k.sendFile(g, D), j = URL.createObjectURL(g), L = JSON.parse(k.metadata || "{}"), N = {
        id: `chat-${Date.now()}-${Math.random().toString(36).substring(2, 6)}`,
        streamId: z.id,
        fileName: g.name,
        fileSize: g.size,
        mimeType: g.type,
        senderName: k.name || k.identity,
        senderIdentity: k.identity,
        senderIdentityType: L == null ? void 0 : L.identityType,
        senderAvatar: L == null ? void 0 : L.avatar,
        senderRole: L == null ? void 0 : L.role,
        timestamp: Date.now(),
        isOwn: !0,
        url: j
      }, R = o();
      return R ? R.addMessage(N) : s.value.push(N), w.value.delete("upload"), h.value = !1, c.value = 0, N;
    } catch (P) {
      throw h.value = !1, c.value = 0, P;
    }
  }), v = () => {
    s.value.forEach((E) => {
      E.url && URL.revokeObjectURL(E.url);
    });
    const g = o();
    g ? g.messages.value = [] : s.value = [], d.clear(), w.value.clear();
  }, l = () => {
    const g = t.value;
    if (!g)
      return null;
    g.state === "connected" && i();
    const E = () => {
      i();
    };
    g.on(F.Connected, E);
    const b = () => {
      he.delete(g), me.delete(g);
    };
    return g.on(F.Disconnected, b), () => {
      g.off(F.Connected, E), g.off(F.Disconnected, b);
    };
  };
  let f = null;
  return t.value && (f = l()), Q(() => {
    v(), f && f();
  }), {
    fileMessages: s,
    fileProgress: w,
    isUploading: h,
    uploadProgress: c,
    sendFile: e,
    clearFileMessages: v
  };
}
function Aa(n) {
  return n.startsWith("image/") ? "images" : n.startsWith("video/") ? "videos" : n.startsWith("audio/") ? "audios" : n.startsWith("text/") ? "texts" : n.includes("pdf") || n.includes("document") || n.includes("spreadsheet") || n.includes("presentation") || n.includes("msword") || n.includes("ms-excel") || n.includes("ms-powerpoint") || n.includes("officedocument") ? "documents" : "unknowns";
}
function Da(n, t) {
  return y(this, null, function* () {
    return new Promise((a, o) => {
      const r = new XMLHttpRequest();
      r.open("PUT", t, !0), r.setRequestHeader("Content-Type", n.type), r.onload = () => {
        r.status === 200 ? a() : o(new Error(`Upload failed with status: ${r.status}`));
      }, r.onerror = () => o(new Error("Upload failed")), r.send(n);
    });
  });
}
function Ra(n, t = 3, a = 1e3) {
  return y(this, null, function* () {
    let o;
    for (let r = 1; r <= t; r++)
      try {
        return yield n();
      } catch (s) {
        if (o = s, r === t) break;
        const w = a * Math.pow(2, r - 1);
        yield new Promise((d) => setTimeout(d, w));
      }
    throw o;
  });
}
function nn() {
  const n = ye("assetId", S(""));
  return {
    recordMessage: (a) => y(this, null, function* () {
      try {
        if (!n.value)
          return;
        let o;
        return yield Ra(() => y(this, null, function* () {
          let r;
          if (a.attachment) {
            const w = yield (yield fetch(a.attachment.url)).blob(), d = new File([w], a.attachment.name, {
              type: a.attachment.type
            }), h = Aa(a.attachment.type), c = yield zt.getUploadSignedUrl({
              assetId: n.value,
              type: h,
              mimeType: a.attachment.type,
              bucketType: "own"
            });
            yield Da(d, c.signedUrl), r = `https://storage.googleapis.com/${c.bucket}/${c.path}`;
          }
          o = {
            identity: a.senderIdentity,
            text: a.text,
            senderName: a.senderName,
            senderAvatar: a.senderAvatar,
            senderRole: a.senderRole,
            senderIdentity: a.senderIdentity,
            senderIdentityType: a.senderIdentityType,
            timestamp: a.timestamp,
            attachments: a.attachment ? [
              {
                id: a.attachment.id,
                name: a.attachment.name,
                size: a.attachment.size,
                type: a.attachment.type,
                url: r
              }
            ] : void 0
          }, yield ge.addChat(n.value, o);
        })), o;
      } catch (o) {
      }
    })
  };
}
let fe = null, pe = !1;
function rn() {
  const n = S(!1), t = S(pe), a = S(!1), o = S(null);
  let r = null, s = null;
  const w = () => y(this, null, function* () {
    return pe ? (t.value = !0, !0) : fe || (fe = new Promise((i, e) => {
      try {
        if (n.value = !0, o.value = null, window.EmojiMart) {
          pe = !0, t.value = !0, i(!0);
          return;
        }
        const v = document.createElement("script");
        v.src = "https://cdn.jsdelivr.net/npm/emoji-mart@5.6.0/dist/browser.js", v.async = !0, v.onload = () => {
          if (window.EmojiMart)
            pe = !0, t.value = !0, i(!0);
          else {
            const l = "emoji-mart failed to initialize";
            o.value = l, e(new Error(l));
          }
        }, v.onerror = () => {
          const l = "Failed to load emoji-mart from CDN";
          o.value = l, e(new Error(l));
        }, document.head.appendChild(v);
      } catch (v) {
        const l = v instanceof Error ? v.message : "Unknown error loading emoji-mart";
        o.value = l, e(new Error(l));
      } finally {
        n.value = !1;
      }
    }), fe);
  }), d = (f, g, ...E) => y(this, [f, g, ...E], function* (i, e, v = {}, l = {}) {
    try {
      if (h(), !(yield w()))
        throw new Error("Failed to load emoji picker");
      const m = J({
        theme: "auto",
        set: "native",
        previewPosition: "none",
        skinTonePosition: "search",
        searchPosition: "sticky",
        perLine: 8,
        emojiSize: 24,
        emojiButtonSize: 32,
        maxFrequentRows: 2,
        locale: "en"
      }, v), k = te(J({}, m), {
        data: () => y(this, null, function* () {
          const C = yield fetch(
            "https://cdn.jsdelivr.net/npm/@emoji-mart/data"
          );
          if (!C.ok)
            throw new Error("Failed to load emoji data");
          return C.json();
        }),
        onEmojiSelect: (C) => {
          e(C), h();
        },
        onClickOutside: () => {
          h();
        }
      });
      if (r = new window.EmojiMart.Picker(k), yield new Promise((C) => setTimeout(C, 100)), !r)
        throw new Error("Failed to create emoji picker instance");
      s = document.createElement("div");
      const D = J(J({}, {
        position: "fixed",
        // Use fixed instead of absolute for better positioning
        zIndex: "9999",
        // Higher z-index to ensure visibility
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
        borderRadius: "10px",
        overflow: "hidden",
        backgroundColor: "white"
        // Ensure background
      }), l);
      Object.assign(s.style, D);
      const z = i.getBoundingClientRect(), j = window.innerHeight, L = window.innerWidth, N = 400, R = 352;
      z.bottom + N > j && z.top > N ? s.style.bottom = `${j - z.top + 8}px` : s.style.top = `${z.bottom + 8}px`;
      let _ = z.left;
      _ + R > L && (_ = L - R - 8), _ < 8 && (_ = 8), s.style.left = `${_}px`, s.appendChild(r), document.body.appendChild(s), a.value = !0;
    } catch (b) {
      const m = b instanceof Error ? b.message : "Failed to show emoji picker";
      o.value = m;
    }
  }), h = () => {
    try {
      s && (s.parentNode && s.parentNode.removeChild(s), s = null), r && (r = null), a.value = !1;
    } catch (i) {
      s = null, r = null, a.value = !1;
    }
  }, c = (f, g, ...E) => y(this, [f, g, ...E], function* (i, e, v = {}, l = {}) {
    a.value ? h() : yield d(i, e, v, l);
  });
  return Q(() => {
    h();
  }), {
    isLoading: n,
    isLoaded: t,
    isOpen: a,
    error: o,
    showPicker: d,
    hidePicker: h,
    togglePicker: c,
    loadEmojiMart: w
  };
}
var xa = /* @__PURE__ */ ((n) => (n.MESSAGE_RECEIVED = "message_received", n.PARTICIPANT_JOINED = "participant_joined", n.SCREEN_SHARE_STARTED = "screen_share_started", n.HAND_RAISED = "hand_raised", n))(xa || {});
const Ia = {
  message_received: "https://storage.googleapis.com/revex-assets-drm-staging/live-session-assets/sounds/new-message.mp3",
  participant_joined: "https://storage.googleapis.com/revex-assets-drm-staging/live-session-assets/sounds/participant-joined.mp3",
  screen_share_started: "https://storage.googleapis.com/revex-assets-drm-staging/live-session-assets/sounds/screen-share.mp3",
  hand_raised: "https://storage.cloud.google.com/revex-assets-drm-staging/live-session-assets/sounds/hand_raise1.mp3"
};
function on() {
  return {
    playSound: (t) => y(this, null, function* () {
      try {
        const a = Ia[t];
        if (!a)
          return;
        const o = new Audio(a);
        o.volume = 0.3;
        const r = o.play();
        r !== void 0 && (yield r);
      } catch (a) {
      }
    })
  };
}
function sn(n = {}) {
  const {
    pageSize: t = 50,
    autoLoadOnMount: a = !0,
    onError: o,
    onHistoryLoaded: r
  } = n, s = ye("assetId", S("")), w = S([]), d = S(!0), h = S(void 0), c = S(!1), i = S(!1), e = S(!1), v = S(null), l = (m) => {
    var k;
    return {
      id: m._id,
      text: m.text || "",
      senderName: m.senderName || "Unknown",
      senderAvatar: m.senderAvatar || "",
      senderRole: m.senderRole,
      senderIdentity: m.senderIdentity,
      senderIdentityType: m.senderIdentityType || "",
      timestamp: m.timestamp,
      isOwn: !1,
      // Will be determined by the component based on current user
      attachment: (k = m.attachments) != null && k[0] ? {
        id: m.attachments[0].id || "",
        name: m.attachments[0].name || "",
        size: m.attachments[0].size || 0,
        type: m.attachments[0].type || "",
        url: m.attachments[0].url || ""
      } : void 0
    };
  }, f = () => y(this, null, function* () {
    if (!(!s.value || c.value))
      try {
        c.value = !0, v.value = null;
        const m = {
          limit: t
          // No cursor for initial load - gets most recent messages
        }, k = yield ge.getChats(s.value, m), P = k.chats.map(l);
        P.sort((D, z) => D.timestamp - z.timestamp), w.value = P, d.value = k.hasMore, h.value = k.nextCursor, r == null || r(P, !0);
      } catch (m) {
        const k = m instanceof Error ? m.message : "Failed to load chat history";
        v.value = k, o == null || o(m instanceof Error ? m : new Error(k));
      } finally {
        c.value = !1;
      }
  }), g = () => y(this, null, function* () {
    if (!(!s.value || i.value || !d.value || !h.value))
      try {
        i.value = !0, v.value = null;
        const m = {
          limit: t,
          cursor: h.value
        }, k = yield ge.getChats(s.value, m), P = k.chats.map(l);
        P.sort((D, z) => D.timestamp - z.timestamp), w.value = [...P, ...w.value], d.value = k.hasMore, h.value = k.nextCursor, r == null || r(P, !1);
      } catch (m) {
        const k = m instanceof Error ? m.message : "Failed to load more messages";
        v.value = k, o == null || o(m instanceof Error ? m : new Error(k));
      } finally {
        i.value = !1;
      }
  }), E = () => y(this, null, function* () {
    if (!(!s.value || e.value))
      try {
        e.value = !0, v.value = null, h.value = void 0, d.value = !0;
        const m = {
          limit: t
        }, k = yield ge.getChats(s.value, m), P = k.chats.map(l);
        P.sort((D, z) => D.timestamp - z.timestamp), w.value = P, d.value = k.hasMore, h.value = k.nextCursor, r == null || r(P, !0);
      } catch (m) {
        const k = m instanceof Error ? m.message : "Failed to refresh chat";
        v.value = k, o == null || o(m instanceof Error ? m : new Error(k));
      } finally {
        e.value = !1;
      }
  }), b = () => {
    w.value = [], d.value = !0, h.value = void 0, c.value = !1, i.value = !1, e.value = !1, v.value = null;
  };
  return Z(
    s,
    (m) => {
      m && a && (b(), f());
    },
    { immediate: !0 }
  ), {
    // Data
    historicalMessages: w,
    hasMore: d,
    nextCursor: h,
    // Loading states
    isInitialLoading: c,
    isLoadingMore: i,
    isRefreshing: e,
    // Error state
    error: v,
    // Methods
    loadInitialHistory: f,
    loadMoreHistory: g,
    refresh: E,
    reset: b
  };
}
function cn(n, t) {
  const a = /* @__PURE__ */ new Map();
  return n.forEach((r) => {
    a.set(r.id, r);
  }), t.forEach((r) => {
    a.set(r.id, r);
  }), Array.from(a.values()).sort((r, s) => r.timestamp - s.timestamp);
}
export {
  Xa as A,
  Ga as B,
  ke as C,
  xa as N,
  Re as O,
  Ya as P,
  je as a,
  ta as b,
  qa as c,
  Va as d,
  W as e,
  Ha as f,
  Ba as g,
  Wa as h,
  Ca as i,
  we as j,
  Za as k,
  en as l,
  Qa as m,
  tn as n,
  Ja as o,
  an as p,
  nn as q,
  rn as r,
  sn as s,
  cn as t,
  Ie as u,
  on as v,
  $a as w,
  na as x,
  Ka as y,
  Ht as z
};
